import { D as bt, T as gt, i as vt, n as Q, s as yt, t as At, v as St } from "./layout-BD1t4ofR.js";
import { n as y } from "./Logger-CmiOOsKC.js";
import { p as Tt, t as R } from "./tracebehavior-5_qSKjs6.js";
import { n as ne, r as xe, t as Le } from "./TransformUtils-Bd2LIBHs.js";
import { $ as xt, D as Ot, E as Rt, F as wt, St as p, at as Pt, b as Ct, g as Et, m as Mt, p as It, tt as Vt, v as Nt, vt as kt, wt as Bt } from "./SceneCreation-DVCYLXYF.js";
import { i as jt } from "./TransitionManager-BD_yHXIb.js";
import { t as Ft } from "./animationsequence-C8TMiBUE.js";
import { i as ft, n as J, s as He, t as Dt } from "./playable-tG_Q2o5X.js";
import { t as Be } from "./audioclip-D2YGwkWS.js";
import { H as ye, L as ze, Q as zt, V as Lt, X as je, i as ae, r as Ht } from "./ScriptRegistry-C3vqndus.js";
import { r as Gt, t as Zt } from "./boxcollider-DfK5pGI3.js";
import { a as qt, i as Ge, o as Ut, t as I } from "./properties-C_pgb9zu.js";
import { t as Xt } from "./ModelLoader-CCmBcIkj.js";
import { a as Ze, i as qe, l as Kt, n as Wt, o as Ue, r as Yt, s as Jt, t as Qt } from "./morphstretch-YfBvUhFE.js";
import { t as $t } from "./imageanchor-DusNzbVp.js";
import { t as es } from "./text-CeJQaWao.js";
import { Matrix as Te, Quaternion as w, Vector3 as m } from "@babylonjs/core/Maths/math.vector.js";
import { Observable as Xe } from "@babylonjs/core/Misc/observable.js";
import { MeshBuilder as Ae } from "@babylonjs/core/Meshes/meshBuilder.js";
import { PointerEventTypes as Oe } from "@babylonjs/core/Events/pointerEvents.js";
import { AdvancedDynamicTexture as Ke } from "@babylonjs/gui/2D/advancedDynamicTexture.js";
import { TextBlock as oe } from "@babylonjs/gui/2D/controls/textBlock.js";
import { Rectangle as F } from "@babylonjs/gui/2D/controls/rectangle.js";
import { Control as E } from "@babylonjs/gui/2D/controls/control.js";
import { Color3 as Re, Color4 as z } from "@babylonjs/core/Maths/math.color.js";
import { AbstractMesh as ts } from "@babylonjs/core/Meshes/abstractMesh.js";
import { StackPanel as $ } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { Button as ee } from "@babylonjs/gui/2D/controls/button.js";
import { Checkbox as ss } from "@babylonjs/gui/2D/controls/checkbox.js";
import { InputText as le } from "@babylonjs/gui/2D/controls/inputText.js";
import { Slider as is } from "@babylonjs/gui/2D/controls/sliders/slider.js";
import { ColorPicker as rs } from "@babylonjs/gui/2D/controls/colorpicker.js";
import { Texture as ce } from "@babylonjs/core/Materials/Textures/texture.js";
import { ParticleSystem as ns } from "@babylonjs/core/Particles/particleSystem.js";
import { Tools as k } from "@babylonjs/core/Misc/tools.js";
import { Constants as We } from "@babylonjs/core/Engines/constants.js";
import { BoxParticleEmitter as we } from "@babylonjs/core/Particles/EmitterTypes/boxParticleEmitter.js";
import { ConeParticleEmitter as Pe } from "@babylonjs/core/Particles/EmitterTypes/coneParticleEmitter.js";
import { SphereParticleEmitter as Ye } from "@babylonjs/core/Particles/EmitterTypes/sphereParticleEmitter.js";
import { NoiseProceduralTexture as as } from "@babylonjs/core/Materials/Textures/Procedurals/noiseProceduralTexture.js";
var Je = /* @__PURE__ */ new WeakMap(), os = class extends R {
  static behaviorType = "AudioSource";
  _mediaSource = null;
  _inputGain = null;
  _dryGain = null;
  _wetGain = null;
  _panner = null;
  _host = null;
  _hostReadyObserver = null;
  _siblingObserver = null;
  _positionObserver = null;
  _lastPosX = 0;
  _lastPosY = 0;
  _lastPosZ = 0;
  validate(t) {
    const e = [];
    return t.volume !== void 0 && (t.volume < 0 || t.volume > 1) && e.push({
      field: "volume",
      message: "Volume must be 0–1"
    }), t.minDistance !== void 0 && t.minDistance < 0 && e.push({
      field: "minDistance",
      message: "Min distance must be >= 0"
    }), t.maxDistance !== void 0 && t.maxDistance < 0 && e.push({
      field: "maxDistance",
      message: "Max distance must be >= 0"
    }), t.minDistance !== void 0 && t.maxDistance !== void 0 && t.minDistance > t.maxDistance && e.push({
      field: "maxDistance",
      message: "maxDistance must be >= minDistance"
    }), t.spatialBlend !== void 0 && (t.spatialBlend < 0 || t.spatialBlend > 1) && e.push({
      field: "spatialBlend",
      message: "spatialBlend must be 0–1"
    }), e;
  }
  onAttach() {
    const t = this._findHost();
    if (t) {
      this._bindHost(t);
      return;
    }
    y.debug(`[AudioSource] No Video or AudioClip sibling on "${this.sceneObject.name}" yet; waiting for one.`), this._siblingObserver = this.sceneObject.onBehaviorAddedObservable.add((e) => {
      (e instanceof je || e instanceof Be) && (this._stopWatchingSiblings(), this._bindHost(e));
    });
  }
  onDetach() {
    this._stopWatchingSiblings(), this._hostReadyObserver && this._host && (this._host.onMediaElementReadyObservable.remove(this._hostReadyObserver), this._hostReadyObserver = null), this._removePositionObserver(), this._teardownGraph(), this._host = null;
  }
  _findHost() {
    const t = this.sceneObject.getBehavior(je), e = t ? null : this.sceneObject.getBehavior(Be);
    return t ?? e;
  }
  _stopWatchingSiblings() {
    this._siblingObserver && (this.sceneObject.onBehaviorAddedObservable.remove(this._siblingObserver), this._siblingObserver = null);
  }
  _bindHost(t) {
    this._host = t;
    const e = t.getMediaElement();
    e ? this._hookMediaElement(e) : this._hostReadyObserver = t.onMediaElementReadyObservable.add((s) => {
      this._hookMediaElement(s);
    });
  }
  async applyCommit() {
    this._applyParams();
  }
  get _audioManager() {
    return this.sceneObject.traceScene.getAudioManager();
  }
  _hookMediaElement(t) {
    this._inputGain && (this._removePositionObserver(), this._teardownGraph());
    const e = this._audioManager, s = e.getContext();
    let i = Je.get(t);
    if (i) try {
      i.disconnect();
    } catch {
    }
    else try {
      i = s.createMediaElementSource(t), Je.set(t, i);
    } catch (c) {
      y.warn(`[AudioSource] Failed to create media element source: ${c instanceof Error ? c.message : String(c)}`);
      return;
    }
    this._mediaSource = i;
    const r = s.createGain(), n = s.createGain(), a = s.createPanner();
    a.panningModel = "HRTF";
    const o = s.createGain(), l = this._emitterPosition(), h = s.currentTime;
    a.positionX.setValueAtTime(l.x, h), a.positionY.setValueAtTime(l.y, h), a.positionZ.setValueAtTime(l.z, h), this._lastPosX = l.x, this._lastPosY = l.y, this._lastPosZ = l.z, i.connect(r), r.connect(n), r.connect(a), a.connect(o), n.connect(e.getDestination()), o.connect(e.getDestination()), this._inputGain = r, this._dryGain = n, this._wetGain = o, this._panner = a, this._applyParams(), this._ensurePositionObserver();
  }
  _applyParams() {
    if (!this._inputGain) return;
    const t = this._audioManager.getContext(), e = this._resolved.volume ?? 1, s = Math.max(0, Math.min(1, this._resolved.spatialBlend ?? 1)), i = this._resolved.minDistance ?? 1, r = Math.max(i, this._resolved.maxDistance ?? 10), n = this._resolved.volumeRollOff ?? "Linear", a = t.currentTime;
    this._inputGain.gain.setValueAtTime(e, a), this._dryGain.gain.setValueAtTime(1 - s, a), this._wetGain.gain.setValueAtTime(s, a);
    const o = this._panner;
    o.distanceModel = n === "Logarithmic" ? "inverse" : "linear", o.refDistance = i, o.maxDistance = r, o.rolloffFactor = 1;
  }
  _emitterPosition() {
    return (this.sceneObject.animationRoot ?? this.sceneObject.transform).getAbsolutePosition();
  }
  _ensurePositionObserver() {
    this._positionObserver || !this.scene || !this._panner || (this._positionObserver = this.scene.onBeforeRenderObservable.add(() => {
      if (!this._panner) return;
      const t = this._emitterPosition(), e = t.x - this._lastPosX, s = t.y - this._lastPosY, i = t.z - this._lastPosZ;
      e * e + s * s + i * i < 1e-6 || (this._lastPosX = t.x, this._lastPosY = t.y, this._lastPosZ = t.z, this._panner.positionX.value = t.x, this._panner.positionY.value = t.y, this._panner.positionZ.value = t.z);
    }));
  }
  _removePositionObserver() {
    this._positionObserver && this.scene && (this.scene.onBeforeRenderObservable.remove(this._positionObserver), this._positionObserver = null);
  }
  _teardownGraph() {
    try {
      this._mediaSource?.disconnect();
    } catch {
    }
    try {
      this._inputGain?.disconnect();
    } catch {
    }
    try {
      this._dryGain?.disconnect();
    } catch {
    }
    try {
      this._wetGain?.disconnect();
    } catch {
    }
    try {
      this._panner?.disconnect();
    } catch {
    }
    if (this._mediaSource) try {
      this._mediaSource.connect(this._audioManager.getDestination());
    } catch {
    }
    this._inputGain = null, this._dryGain = null, this._wetGain = null, this._panner = null, this._mediaSource = null;
  }
}, Fe = class extends R {
  static behaviorType = "Keyframes";
  _activeKeyframe = null;
  _contributedPaths = /* @__PURE__ */ new Set();
  get _contributorId() {
    return this.sceneObject.transform.uniqueId;
  }
  onPlayModeChanged(t) {
    t ? this._resolved.initialKeyframe && this.goTo(this._resolved.initialKeyframe, !1) : this.goTo(null, !1);
  }
  onDetach() {
    this._clearAllContributions(!0), this._activeKeyframe = null;
  }
  getActiveKeyframe() {
    return this._activeKeyframe;
  }
  reapply() {
    const t = this._activeKeyframe;
    t && this._resolved.keyframes?.[t] && this._goToInternal(t, !1, !0);
  }
  getKeyframeNames() {
    return Object.keys(this._resolved.keyframes ?? {});
  }
  async next(t = !0) {
    const e = this.getKeyframeNames();
    if (e.length === 0) return;
    const s = ((this._activeKeyframe ? e.indexOf(this._activeKeyframe) : -1) + 1) % e.length;
    await this.goTo(e[s], t);
  }
  async prev(t = !0) {
    const e = this.getKeyframeNames();
    if (e.length === 0) return;
    const s = this._activeKeyframe ? e.indexOf(this._activeKeyframe) : -1, i = s <= 0 ? e.length - 1 : s - 1;
    await this.goTo(e[i], t);
  }
  async goTo(t, e = !0) {
    return this._goToInternal(t, e, !1);
  }
  async _goToInternal(t, e, s) {
    const i = this._resolved.keyframes;
    if (!i || t !== null && !i[t]) return;
    const r = this._activeKeyframe;
    if (!s && r === t) return;
    this._activeKeyframe = t;
    const n = {
      duration: this._resolved.transitionDuration ?? 0.5,
      easing: this._resolved.transitionEasing ?? "easeInOut"
    };
    if (!t) {
      this._clearAllContributions(!e, n);
      return;
    }
    const a = i[t], o = a.entries ?? {}, l = a.transition ?? n, h = r ? i[r]?.entries ?? {} : {}, c = /* @__PURE__ */ new Set();
    for (const [u, _] of Object.entries(o)) {
      const b = this._resolveTarget(u);
      if (!b) continue;
      const v = b.getBehavior(I);
      if (!v) {
        y.warn(`[Keyframes] Skipping entry for path "${u}" — target has no Properties behavior. Keyframe targets must declare Properties to receive state contributions.`);
        continue;
      }
      const S = this._entryToStateDefinition(_, l), A = h[u]?.enterFrom;
      S.enterFrom === void 0 && A !== void 0 && (S.enterFrom = A), r && this._contributedPaths.has(u) ? v.replaceContribution(this._contributorId, r, t, S, !e, S.transition) : v.pushContribution(this._contributorId, t, S, !e, S.transition), c.add(u);
    }
    for (const u of this._contributedPaths) {
      if (c.has(u)) continue;
      const _ = this._resolveTarget(u)?.getBehavior(I);
      _ && _.clearAllContributions(this._contributorId, !e, l);
    }
    this._contributedPaths = c;
  }
  _entryToStateDefinition(t, e) {
    const s = {
      values: { ...t.values ?? {} },
      transition: t.transition ?? e
    };
    return t.transform && (s.transform = t.transform), t.active !== void 0 && (s.active = t.active), t.enterFrom && (s.enterFrom = t.enterFrom), s;
  }
  _resolveTarget(t) {
    return t === "./" ? this.sceneObject : this.sceneObject.traceScene.resolveSceneObject(t, this.sceneObject) ?? null;
  }
  _clearAllContributions(t, e) {
    for (const s of this._contributedPaths) {
      const i = this._resolveTarget(s)?.getBehavior(I);
      i && i.clearAllContributions(this._contributorId, t, e);
    }
    this._contributedPaths.clear();
  }
};
function ls(t, e = 0, s = 100, i = 0) {
  if (!Number.isFinite(t)) return String(t);
  const r = i > 0 ? i : Math.abs(s - e) / 1e3, [n, a = "0"] = r.toString().toLowerCase().split("e"), o = (n.split(".")[1]?.length ?? 0) - Number(a), l = i > 0 ? o : Math.ceil(-Math.log10(r)), h = r > 0 ? Math.min(6, Math.max(1, l)) : 1, c = t.toFixed(h);
  return t !== 0 && Number(c) === 0 ? t.toExponential(2) : h > 1 ? c.replace(/(\.\d*?[1-9])0+$|\.0+$/, "$1") : c;
}
var Qe = new Map(gt.map((t) => [t.type, t])), De = null;
function Bi(t) {
  De = t;
}
var cs = class extends R {
  static behaviorType = "AutoUI";
  advancedTexture = null;
  rootPanel = null;
  readoutControl = null;
  panelCollapsed;
  updateCollapse = null;
  worldSpacePlane = null;
  trackedControls = [];
  renderObserver = null;
  structureObserver = null;
  structureFingerprint = "";
  _safeAreaHandler = null;
  _lastCssWidth = 0;
  _discoveryRoot = null;
  init() {
  }
  onAttach(t) {
    this.disposeUI(), this._discoveryRoot = this.resolveDiscoveryRoot(), this.buildUI(), this.startStructurePolling(), this._subscribeSafeArea();
  }
  onDetach() {
    this._unsubscribeSafeArea(), this.stopStructurePolling(), this.disposeUI();
  }
  async applyCommit(t) {
    if (this.attachedNode) {
      if (Object.keys(t).every((e) => e === "readout") && this.readoutControl && this._resolved.readout !== void 0) {
        this.readoutControl.text = this._resolved.readout;
        return;
      }
      ("collapsible" in t || "collapseBelowWidth" in t) && (this.panelCollapsed = void 0), this._discoveryRoot = this.resolveDiscoveryRoot(), this.disposeUI(), this.buildUI(), this.structureFingerprint = this.computeStructureFingerprint();
    }
  }
  discoverLabeledItems() {
    const t = [], e = this.getAllDescendantSceneObjects(), s = new Set(e), i = s.has(this.sceneObject) ? e : [this.sceneObject, ...e];
    for (const r of new Set(i)) {
      const n = r.getBehavior(I), a = s.has(r) ? (n?.getProperties() ?? []).filter((l) => !l.hidden) : [], o = this.discoverActions(r);
      (a.length > 0 || o.length > 0) && t.push({
        source: r,
        properties: a,
        actions: o
      });
    }
    return y.debug(`[AutoUI] Discovered ${t.length} objects with labeled items`), t;
  }
  discoverActions(t) {
    const e = [];
    for (const s of t.getBehaviors()) {
      const i = Qe.get(s.name);
      if (i?.actions)
        for (const r of i.actions) {
          const n = this.bindAction(t, s.name, r);
          n && e.push(n);
        }
    }
    return e;
  }
  bindAction(t, e, s) {
    switch (e) {
      case ye.behaviorType: {
        const i = t.getBehavior(ye);
        return i ? s.name === "next" ? {
          name: "next",
          label: s.label,
          execute: () => {
            i.next();
          }
        } : s.name === "prev" ? {
          name: "prev",
          label: s.label,
          execute: () => {
            i.prev();
          }
        } : null : null;
      }
      case Fe.behaviorType: {
        const i = t.getBehavior(Fe);
        return i ? s.name === "next" ? {
          name: "next",
          label: s.label,
          execute: () => {
            i.next();
          }
        } : s.name === "prev" ? {
          name: "prev",
          label: s.label,
          execute: () => {
            i.prev();
          }
        } : null : null;
      }
      default:
        return null;
    }
  }
  resolveDiscoveryRoot() {
    const t = this.sceneObject.traceScene;
    if (this._resolved.propertyGroups && this._resolved.propertyGroups.length > 0) {
      const e = this._resolved.propertyGroups[0], s = t.resolveSceneObject(e, this.sceneObject) ?? t.resolveSceneObject(e, this.sceneObject.getParent() ?? void 0);
      if (s)
        return y.debug(`[AutoUI] Using propertyGroups root: "${e}"`), s;
      const i = this.sceneObject.getParent();
      if (i)
        return y.warn(`[AutoUI] propertyGroups target "${e}" not found, falling back to parent "${i.name}"`), i;
      y.warn(`[AutoUI] propertyGroups target "${e}" not found, falling back to self`);
    }
    return this.sceneObject;
  }
  getAllDescendantSceneObjects() {
    return this._discoveryRoot || (this._discoveryRoot = this.resolveDiscoveryRoot()), [this._discoveryRoot, ...this._discoveryRoot.getDescendants()];
  }
  buildUI() {
    if (!this.sceneObject.babylonScene.getEngine().getRenderingCanvas()) return !1;
    const t = this.discoverLabeledItems();
    if (t.length === 0 && this._resolved.readout === void 0 && !this._resolved.cameraViews?.length)
      return y.debug("[AutoUI] No labeled properties or interactions found"), !1;
    if (this.createAdvancedTexture(), !this.advancedTexture) return !1;
    const e = this._resolved.width ?? 300;
    this.rootPanel = this.createRootPanel(e), this.advancedTexture.addControl(this.rootPanel);
    const s = new $("autoui-content");
    s.width = "100%", s.paddingTop = "10px", s.paddingBottom = "10px", s.paddingLeft = "10px", s.paddingRight = "10px", this.rootPanel.addControl(s);
    const i = new $("autoui-body");
    if (i.width = "100%", this._resolved.collapsible) {
      const r = this.sceneObject.babylonScene.getEngine();
      this.panelCollapsed ??= r.getRenderWidth() * r.getHardwareScalingLevel() < (this._resolved.collapseBelowWidth ?? 0);
      const n = ee.CreateSimpleButton("autoui-toggle", "");
      n.height = "36px", n.width = "100%", n.thickness = 0, n.color = "#EEF5F8", n.background = "transparent", n.fontSize = 16, n.hoverCursor = "pointer";
      const a = () => {
        i.isVisible = !this.panelCollapsed, n.textBlock.text = `${this._resolved.title ?? "Controls"}  ${this.panelCollapsed ? "+" : "−"}`;
      };
      n.onPointerClickObservable.add(() => {
        this.panelCollapsed = !this.panelCollapsed, a();
      }), this.updateCollapse = a, a(), s.addControl(n);
    } else if (this._resolved.title) {
      const r = new F("autoui-title-wrapper");
      r.width = "100%", r.adaptHeightToChildren = !0, r.thickness = 0, r.paddingBottom = "15px";
      const n = this.createLabel(this._resolved.title, 18, !0);
      n.textHorizontalAlignment = E.HORIZONTAL_ALIGNMENT_LEFT, r.addControl(n), s.addControl(r);
    }
    if (s.addControl(i), this._resolved.cameraViews?.length) {
      const r = new F("autoui-views");
      r.thickness = 0, r.width = "100%", r.height = "34px";
      const n = this._resolved.cameraViews;
      n.forEach((a, o) => {
        const l = ee.CreateSimpleButton(`autoui-view-${o}`, a.label);
        l.width = `${100 / n.length}%`, l.height = "30px", l.horizontalAlignment = E.HORIZONTAL_ALIGNMENT_LEFT, l.left = `${100 * o / n.length}%`, l.paddingRight = "3px", l.background = "#284A59", l.color = "#EEF5F8", l.thickness = 0, l.fontSize = 12, l.hoverCursor = "pointer", l.onPointerClickObservable.add(() => {
          const h = this.sceneObject.traceScene.getCamera();
          if (!h || !Number.isFinite(a.yaw) || !Number.isFinite(a.pitch)) return;
          const c = a.target === void 0 ? this.sceneObject : this.sceneObject.traceScene.resolveSceneObject(a.target, this.sceneObject), u = a.radiusScale ?? 1.1;
          !c || !Number.isFinite(u) || u < 1 || Lt.focusOnNode(h, c.transform, {
            radiusScale: u,
            framingTime: 0
          }, this.sceneObject.traceScene.safeAreaInsets) && (h.inertialAlphaOffset = h.inertialBetaOffset = h.inertialRadiusOffset = 0, h.inertialPanningX = h.inertialPanningY = 0, h.alpha = a.yaw * Math.PI / 180, h.beta = Math.max(0.01, Math.min(Math.PI - 0.01, a.pitch * Math.PI / 180)), this._resolved.collapsible && this._resolved.collapseOnView && (this.panelCollapsed = !0, this.updateCollapse?.()));
        }), r.addControl(l);
      }), i.addControl(r);
    }
    for (const r of t) this.addObjectSection(i, r);
    if (this._resolved.readout !== void 0) {
      const r = this.createLabel(this._resolved.readout, 13);
      r.name = "autoui-readout", r.color = "#DCE7ED", r.textHorizontalAlignment = E.HORIZONTAL_ALIGNMENT_LEFT, r.paddingTop = "14px", r.paddingBottom = "6px", r.textWrapping = !0, r.resizeToFit = !0, r.isHitTestVisible = !1, this.readoutControl = r, i.addControl(r);
    }
    return this.startFrameUpdates(), !0;
  }
  createAdvancedTexture() {
    const t = this.sceneObject.babylonScene, e = this._resolved.renderMode ?? "ScreenSpaceOverlay", s = t.getEngine(), i = s.getRenderWidth() * s.getHardwareScalingLevel();
    switch (e) {
      case "ScreenSpaceOverlay":
      case "ScreenSpaceCamera":
        this.advancedTexture = Ke.CreateFullscreenUI("autoui-texture", !0, t), this.advancedTexture.idealWidth = i, this._lastCssWidth = i;
        break;
      case "WorldSpace":
        this.worldSpacePlane = Ae.CreatePlane("autoui-plane", {
          width: 2,
          height: 3
        }, t), this.worldSpacePlane.parent = this.sceneObject.transform, this.advancedTexture = Ke.CreateForMesh(this.worldSpacePlane, 512, 768);
        break;
    }
  }
  createRootPanel(t) {
    const e = new F("autoui-root");
    if (e.width = `${t}px`, e.adaptHeightToChildren = !0, e.thickness = 1, e.cornerRadius = 8, e.background = "rgba(30, 30, 30, 0.95)", e.color = "#555", e.isPointerBlocker = !0, (this._resolved.renderMode ?? "ScreenSpaceOverlay") !== "WorldSpace") {
      e.horizontalAlignment = E.HORIZONTAL_ALIGNMENT_LEFT, e.verticalAlignment = E.VERTICAL_ALIGNMENT_TOP;
      const s = this._resolved.position ?? {
        x: 20,
        y: 20
      }, i = this.sceneObject.traceScene.safeAreaInsets;
      e.width = `${this.screenPanelWidth(t)}px`, e.left = s.x + i.left, e.top = s.y + i.top;
    }
    return e;
  }
  addObjectSection(t, e) {
    const s = new F(`section-header-${e.source.name}`);
    s.width = "100%", s.adaptHeightToChildren = !0, s.thickness = 0, s.paddingTop = "12px", s.paddingBottom = "6px";
    const i = this.createLabel(e.source.name, 14, !0);
    i.color = "#888", i.textHorizontalAlignment = E.HORIZONTAL_ALIGNMENT_LEFT, s.addControl(i), t.addControl(s);
    for (const a of e.properties) {
      const o = this.createPropertyControl(a, e.source);
      o && t.addControl(o);
    }
    const r = e.actions.find((a) => a.name === "prev"), n = e.actions.find((a) => a.name === "next");
    r && n && t.addControl(this.createCyclerControl(r, n, e.source));
    for (const a of e.actions)
      a === r || a === n || t.addControl(this.createActionButton(a));
  }
  createCyclerControl(t, e, s) {
    const i = new F(`cycler-${s.name}`);
    i.height = "35px", i.paddingBottom = "5px", i.width = "100%", i.thickness = 0;
    const r = ee.CreateSimpleButton("cycler-prev", "<");
    r.width = "30px", r.height = "28px", r.color = "white", r.background = "#4a9eff", r.cornerRadius = 4, r.fontSize = 14, r.horizontalAlignment = E.HORIZONTAL_ALIGNMENT_LEFT, r.hoverCursor = "pointer";
    const n = new oe(`cycler-label-${s.name}`);
    n.color = "white", n.fontSize = 12, n.textHorizontalAlignment = E.HORIZONTAL_ALIGNMENT_CENTER, n.horizontalAlignment = E.HORIZONTAL_ALIGNMENT_CENTER;
    const a = () => {
      const l = s.getBehavior(ye);
      l && (n.text = l.getPageNodes()[l.getActivePageIndex()]?.name ?? "");
    };
    a(), this.trackedControls.push({
      source: s,
      propName: "__pages_active",
      propType: "cyclerLabel",
      update: () => a()
    }), r.onPointerUpObservable.add(() => {
      t.execute(), a();
    });
    const o = ee.CreateSimpleButton("cycler-next", ">");
    return o.width = "30px", o.height = "28px", o.color = "white", o.background = "#4a9eff", o.cornerRadius = 4, o.fontSize = 14, o.horizontalAlignment = E.HORIZONTAL_ALIGNMENT_RIGHT, o.hoverCursor = "pointer", o.onPointerUpObservable.add(() => {
      e.execute(), a();
    }), i.addControl(n), i.addControl(r), i.addControl(o), i;
  }
  createActionButton(t) {
    const e = ee.CreateSimpleButton(`action-${t.name}`, t.label);
    return e.width = "100%", e.height = "30px", e.color = "white", e.background = "#4a9eff", e.cornerRadius = 4, e.paddingTop = "3px", e.paddingBottom = "3px", e.hoverCursor = "pointer", e.onPointerUpObservable.add(() => {
      t.execute(), y.debug(`[AutoUI] Executed action: ${t.name}`);
    }), e;
  }
  _getPropertyValue(t, e) {
    const s = e.getBehavior(I), i = s?.getProperty(t);
    return e.traceScene.isPlayMode() ? qt(Ge(i), s?.getValue(t)) : i?.value;
  }
  unitFor(t) {
    return Ut(Ge(t));
  }
  labelFor(t) {
    const e = t.label ?? t.name, s = t.type === "vec3" || t.type === "number" && t.uiHint === "input" ? this.unitFor(t) : void 0;
    return s ? `${e} (${s})` : e;
  }
  createPropertyControl(t, e) {
    const s = new F(`prop-${t.name}`);
    s.height = "30px", s.paddingBottom = "5px", s.width = "100%", s.thickness = 0;
    const i = this.createLabel(this.labelFor(t), 12);
    i.width = "35%", i.textHorizontalAlignment = E.HORIZONTAL_ALIGNMENT_LEFT, i.horizontalAlignment = E.HORIZONTAL_ALIGNMENT_LEFT, s.addControl(i);
    let r = null;
    switch (t.type) {
      case "string":
        r = this.createStringInput(t, e);
        break;
      case "number":
        r = this.createNumberInput(t, e);
        break;
      case "boolean":
        r = this.createBooleanInput(t, e);
        break;
      case "color":
        r = t.variants?.length ? this.createSwatchRow(t, e) : this.createColorInput(t, e);
        break;
      case "vec3":
        r = this.createVector3Input(t, e);
        break;
    }
    if (r) {
      const n = t.type === "boolean";
      r.horizontalAlignment = n ? E.HORIZONTAL_ALIGNMENT_LEFT : E.HORIZONTAL_ALIGNMENT_RIGHT, n && (r.left = "35%"), s.addControl(r);
    }
    return s;
  }
  createStringInput(t, e) {
    const s = new le(`input-${t.name}`);
    s.width = "65%", s.height = "25px", s.color = "white", s.background = "#444", s.focusedBackground = "#555", s.hoverCursor = "text", s.onFocusSelectAll = !0;
    const i = this._getPropertyValue(t.name, e);
    s.text = typeof i == "string" ? i : "";
    let r = !1;
    s.onTextChangedObservable.add(() => {
      r || this.setPropertyValue(e, t.name, s.text);
    });
    const n = this.trackInputFocus(s);
    return this.trackControl(e, t.name, "string", (a) => {
      if (!n()) try {
        r = !0, s.text = typeof a == "string" ? a : "";
      } finally {
        r = !1;
      }
    }), s;
  }
  createNumberInput(t, e) {
    const s = t;
    if (s.uiHint === "input") return this.createNumberTextInput(s, e);
    const i = new F(`number-container-${t.name}`);
    i.width = "65%", i.height = "20px", i.thickness = 0;
    const r = new is(`slider-${t.name}`);
    r.minimum = s.min ?? 0, r.maximum = s.max ?? 100, r.step = s.step ?? 0, r.value = Number(this._getPropertyValue(t.name, e) ?? 0), r.height = "20px", r.color = "#4a9eff", r.background = "#444", r.hoverCursor = "pointer";
    const n = this.unitFor(t), a = (h) => {
      const c = ls(h, r.minimum, r.maximum, r.step);
      return n ? `${c} ${n}` : c;
    }, o = new oe(`value-${t.name}`);
    o.text = a(Number(this._getPropertyValue(t.name, e) ?? 0)), o.width = n ? "65px" : "45px", o.color = "white", o.fontSize = 11, o.horizontalAlignment = E.HORIZONTAL_ALIGNMENT_RIGHT, o.isHitTestVisible = !1;
    let l = !1;
    return r.onValueChangedObservable.add((h) => {
      l || (o.text = a(h), this.setPropertyValue(e, t.name, h));
    }), i.addControl(r), i.addControl(o), this.trackControl(e, t.name, "number", (h) => {
      const c = Number(h ?? 0);
      try {
        l = !0, r.value = c;
      } finally {
        l = !1;
      }
      o.text = a(c);
    }), i;
  }
  createNumberTextInput(t, e) {
    const s = new le(`input-${t.name}`);
    s.width = "65%", s.height = "25px", s.color = "white", s.background = "#444", s.focusedBackground = "#555", s.hoverCursor = "text", s.onFocusSelectAll = !0;
    const i = this._getPropertyValue(t.name, e);
    s.text = String(typeof i == "number" ? i : 0);
    let r = !1;
    s.onTextChangedObservable.add(() => {
      if (r) return;
      const a = parseFloat(s.text);
      isNaN(a) || this.setPropertyValue(e, t.name, a);
    });
    const n = this.trackInputFocus(s);
    return this.trackControl(e, t.name, "number", (a) => {
      if (!n()) try {
        r = !0, s.text = typeof a == "number" ? String(a) : "0";
      } finally {
        r = !1;
      }
    }), s;
  }
  createBooleanInput(t, e) {
    const s = new ss(`checkbox-${t.name}`);
    s.width = "20px", s.height = "20px", s.isChecked = !!(this._getPropertyValue(t.name, e) ?? !1), s.color = "#4a9eff", s.background = "#444", s.hoverCursor = "pointer";
    let i = !1;
    return s.onIsCheckedChangedObservable.add((r) => {
      i || this.setPropertyValue(e, t.name, r);
    }), this.trackControl(e, t.name, "boolean", (r) => {
      try {
        i = !0, s.isChecked = !!(r ?? !1);
      } finally {
        i = !1;
      }
    }), s;
  }
  createColorInput(t, e) {
    const s = new $(`color-container-${t.name}`);
    s.isVertical = !1, s.width = "65%";
    const i = new rs(`colorpicker-${t.name}`);
    i.width = "80px", i.height = "80px", i.hoverCursor = "pointer";
    const r = this._getPropertyValue(t.name, e), n = typeof r == "string" ? r : "#ffffff";
    i.value = Re.FromHexString(n.substring(0, 7));
    const a = new le(`hex-${t.name}`);
    a.width = "80px", a.height = "25px", a.color = "white", a.background = "#444", a.hoverCursor = "text", a.onFocusSelectAll = !0, a.text = n;
    let o = !1;
    i.onValueChangedObservable.add((h) => {
      if (o) return;
      const c = h.toHexString();
      a.text = c, this.setPropertyValue(e, t.name, c);
    }), a.onTextChangedObservable.add(() => {
      o || /^#[0-9A-Fa-f]{6}$/.test(a.text) && (i.value = Re.FromHexString(a.text), this.setPropertyValue(e, t.name, a.text));
    }), s.addControl(i), s.addControl(a);
    const l = this.trackInputFocus(a);
    return this.trackControl(e, t.name, "color", (h) => {
      const c = typeof h == "string" ? h : "#ffffff";
      try {
        o = !0, l() || (a.text = c), i.value = Re.FromHexString(c.substring(0, 7));
      } catch {
      } finally {
        o = !1;
      }
    }), s;
  }
  createSwatchRow(t, e) {
    const s = new $(`swatch-container-${t.name}`);
    s.isVertical = !1, s.width = "65%";
    const i = t.variants ?? [], r = (l) => typeof l == "string" ? l.substring(0, 7).toLowerCase() : "", n = [];
    for (const l of i) {
      const h = new F(`swatch-${t.name}-${l.name}`);
      h.width = "22px", h.height = "22px", h.thickness = 1, h.color = "#000", h.background = l.value, h.hoverCursor = "pointer", h.onPointerUpObservable.add(() => {
        this._writeSwatchValue(e, t.name, l.value);
      }), s.addControl(h), n.push({
        rect: h,
        value: r(l.value)
      });
    }
    const a = (l) => {
      const h = r(l);
      for (const { rect: c, value: u } of n) {
        const _ = h !== "" && u === h;
        c.thickness = _ ? 3 : 1, c.color = _ ? "#fff" : "#000";
      }
    };
    a(e.getBehavior(I)?.getValue(t.name));
    let o = !1;
    return this.trackControl(e, t.name, "colorResolved", (l) => {
      if (!o)
        try {
          o = !0, a(l);
        } finally {
          o = !1;
        }
    }), s;
  }
  _writeSwatchValue(t, e, s) {
    !t.traceScene.isPlayMode() && De ? De(t, e, s) : t.getBehavior(I)?.setValue(e, s);
  }
  createVector3Input(t, e) {
    const s = new $(`vec3-container-${t.name}`);
    s.isVertical = !1, s.width = "65%";
    const i = this._getPropertyValue(t.name, e) ?? [
      0,
      0,
      0
    ], r = [
      "X",
      "Y",
      "Z"
    ], n = [
      "#f55",
      "#5f5",
      "#55f"
    ], a = [];
    for (let l = 0; l < 3; l++) {
      const h = new oe(`${r[l].toLowerCase()}-label-${t.name}`);
      h.text = r[l], h.width = "14px", h.color = n[l], h.fontSize = 10, s.addControl(h);
      const c = new le(`${r[l].toLowerCase()}-input-${t.name}`);
      c.width = "45px", c.height = "20px", c.color = "white", c.background = "#444", c.hoverCursor = "text", c.onFocusSelectAll = !0, c.text = String(i[l]);
      const u = this.trackInputFocus(c);
      a.push({
        input: c,
        index: l,
        isFocused: u
      });
      const _ = l;
      c.onTextChangedObservable.add(() => {
        if (o) return;
        const b = [...i];
        b[_] = parseFloat(c.text) || 0, this.setPropertyValue(e, t.name, b);
      }), s.addControl(c);
    }
    let o = !1;
    return this.trackControl(e, t.name, "vec3", (l) => {
      const h = l ?? [
        0,
        0,
        0
      ];
      try {
        o = !0;
        for (const { input: c, index: u, isFocused: _ } of a) _() || (c.text = String(h[u]));
      } finally {
        o = !1;
      }
    }), s;
  }
  _subscribeSafeArea() {
    const t = this.sceneObject.traceScene.getEventSystem();
    t && (this._safeAreaHandler = () => this._updatePanelPosition(), t.addEventListener("trace-viewer:safe-area-changed", this._safeAreaHandler));
  }
  _unsubscribeSafeArea() {
    if (!this._safeAreaHandler) return;
    const t = this.sceneObject.traceScene.getEventSystem();
    t && t.removeEventListener("trace-viewer:safe-area-changed", this._safeAreaHandler), this._safeAreaHandler = null;
  }
  screenPanelWidth(t) {
    const e = this.sceneObject.babylonScene.getEngine(), s = e.getRenderWidth() * e.getHardwareScalingLevel(), i = this.sceneObject.traceScene.safeAreaInsets, r = Math.max(0, this._resolved.position?.x ?? 20);
    return Math.max(1, Math.min(t, s - i.left - i.right - r * 2));
  }
  _updatePanelPosition() {
    if (!this.rootPanel || (this._resolved.renderMode ?? "ScreenSpaceOverlay") === "WorldSpace") return;
    const t = this._resolved.position ?? {
      x: 20,
      y: 20
    }, e = this.sceneObject.traceScene.safeAreaInsets;
    this.rootPanel.width = `${this.screenPanelWidth(this._resolved.width ?? 300)}px`, this.rootPanel.left = t.x + e.left, this.rootPanel.top = t.y + e.top;
  }
  createLabel(t, e, s = !1) {
    const i = new oe();
    return i.text = t, i.color = "white", i.fontSize = e, i.fontWeight = s ? "bold" : "normal", i.resizeToFit = !0, i.textWrapping = !0, i;
  }
  trackInputFocus(t) {
    let e = !1;
    return t.onFocusObservable.add(() => {
      e = !0, this.sceneObject.traceScene.guiFocusAcquired();
    }), t.onBlurObservable.add(() => {
      e = !1, this.sceneObject.traceScene.guiFocusReleased();
    }), () => e;
  }
  setPropertyValue(t, e, s) {
    const i = t.getBehavior(I);
    if (!i) return;
    if (t.traceScene.isPlayMode()) {
      i.setValue(e, s);
      return;
    }
    const r = i.getProperty(e);
    if (!r) return;
    const n = {
      ...r,
      value: s
    }, a = i.getProperties().map((o) => o.name === e ? n : o);
    i.commit({ properties: a }), y.debug(`[AutoUI] Set ${t.name}.${e} = ${JSON.stringify(s)}`);
  }
  computeStructureFingerprint() {
    const t = this.getAllDescendantSceneObjects(), e = [];
    for (const s of t) {
      const i = (s.getBehavior(I)?.getProperties() ?? []).filter((n) => !n.hidden), r = [];
      for (const n of s.getBehaviors()) Qe.get(n.name)?.actions && r.push(n.name);
      if (i.length > 0 || r.length > 0) {
        const n = i.map((a) => {
          const { value: o, ...l } = a;
          return JSON.stringify(l);
        }).join(",");
        e.push(`${s.name}:p(${n}):a(${r.join(",")})`);
      }
    }
    return e.join("|");
  }
  startStructurePolling() {
    this.stopStructurePolling(), this.structureFingerprint = this.computeStructureFingerprint(), this.structureObserver = this.sceneObject.babylonScene.onBeforeRenderObservable.add(() => {
      const t = this.computeStructureFingerprint();
      t !== this.structureFingerprint && (this.structureFingerprint = t, this.disposeUI(), this.buildUI());
    });
  }
  stopStructurePolling() {
    this.structureObserver && (this.sceneObject.babylonScene.onBeforeRenderObservable.remove(this.structureObserver), this.structureObserver = null);
  }
  disposeUI() {
    this.readoutControl = null, this.updateCollapse = null, this.stopFrameUpdates(), this.trackedControls = [], this.advancedTexture && (this.advancedTexture.focusedControl = null, this.advancedTexture.dispose(), this.advancedTexture = null), this.worldSpacePlane && (this.worldSpacePlane.dispose(), this.worldSpacePlane = null), this.rootPanel = null;
  }
  startFrameUpdates() {
    if (this.renderObserver !== null) return;
    const t = this.sceneObject.babylonScene;
    this.renderObserver = t.onBeforeRenderObservable.add(() => {
      this.updateTrackedControls();
    });
  }
  stopFrameUpdates() {
    this.renderObserver !== null && (this.sceneObject.babylonScene.onBeforeRenderObservable.remove(this.renderObserver), this.renderObserver = null);
  }
  updateVisibility() {
    this.rootPanel && (this._resolved.renderMode ?? "ScreenSpaceOverlay") !== "WorldSpace" && (this.rootPanel.isVisible = this.sceneObject.transform.isEnabled());
  }
  updateIdealWidth() {
    if (!this.advancedTexture || (this._resolved.renderMode ?? "ScreenSpaceOverlay") === "WorldSpace") return;
    const t = this.sceneObject.babylonScene.getEngine(), e = t.getRenderWidth() * t.getHardwareScalingLevel();
    e !== this._lastCssWidth && e > 1 && (this._lastCssWidth = e, this.advancedTexture.idealWidth = e, this._updatePanelPosition());
  }
  updateTrackedControls() {
    this.updateIdealWidth(), this.updateVisibility();
    for (const t of this.trackedControls) {
      if (t.propType === "cyclerLabel") {
        t.update(void 0);
        continue;
      }
      const e = t.source.getBehavior(I);
      if (e) {
        const s = t.propType === "colorResolved" ? e.getValue(t.propName) : this._getPropertyValue(t.propName, t.source);
        t.update(s);
      }
    }
  }
  trackControl(t, e, s, i) {
    this.trackedControls.push({
      source: t,
      propName: e,
      propType: s,
      update: i
    });
  }
}, Ce = new w(), he = new w(), $e = new w(), L = new w(), de = new m(), q = new m(), te = w.Identity(), hs = 1e-5, ds = class extends R {
  static behaviorType = "Billboard";
  _observer = null;
  _lastFrameTime = null;
  _toggle = new ze();
  _settled = !1;
  _holdsTurn = !1;
  setRuntimeEnabled(t) {
    this._toggle.set(t, this._observer !== null);
  }
  isRuntimeEnabled() {
    return this._toggle.enabled;
  }
  load() {
    this.sceneObject.getOrCreateAnimationRoot();
  }
  onPlayModeChanged(t) {
    t ? this._applyBillboard() : this._removeBillboard();
  }
  onDetach() {
    this._removeBillboard();
  }
  async applyCommit(t) {
    this._removeBillboard(), this.playMode && this._applyBillboard();
  }
  _applyBillboard() {
    const t = this.sceneObject.animationRoot;
    if (!t) return;
    const e = this.sceneObject.babylonScene;
    t.rotationQuaternion || (t.rotationQuaternion = w.Identity()), this._lastFrameTime = null, this._settled = !1, this._holdsTurn = !1, this._toggle.reset(this._resolved.enabled ?? !0), this._observer = e.onBeforeRenderObservable.add(() => {
      const s = e.activeCamera;
      if (!s || !t.rotationQuaternion) return;
      const i = this._resolved, r = i.axes ?? [
        "x",
        "y",
        "z"
      ], n = r.includes("y"), a = r.includes("x"), o = s.globalPosition, l = t.parent, h = l ? l.getAbsolutePosition() : t.getAbsolutePosition();
      l ? l.getWorldMatrix().decompose(q, he, void 0) : (q.setAll(1), he.copyFrom(te));
      const c = o.subtract(h), u = i.minDistance ?? 0;
      if (u > 0 && c.lengthSquared() < u * u) {
        this._holdsTurn && ne(t, q);
        return;
      }
      i.reverse && c.negateInPlace();
      const _ = c.length();
      if (_ < 1e-6) {
        this._holdsTurn && ne(t, q);
        return;
      }
      c.scaleInPlace(1 / _);
      let b = this._toggle.enabled;
      const v = i.viewAngle ?? 0;
      if (b && v > 0 && v < 180) {
        de.set(0, 0, 1), de.applyRotationQuaternionToRef(he, de);
        const A = Math.min(1, Math.max(-1, m.Dot(de, c)));
        b = Math.acos(A) * 180 / Math.PI <= v;
      }
      if (b) {
        this._settled = !1;
        const A = n ? Math.atan2(c.x, c.z) : 0, x = a ? Math.atan2(-c.y, Math.sqrt(c.x * c.x + c.z * c.z)) : 0;
        w.RotationYawPitchRollToRef(A, x, 0, Ce), l ? ($e.copyFrom(he).invertInPlace(), $e.multiplyToRef(Ce, L)) : L.copyFrom(Ce);
        const T = i.influence ?? 1;
        T < 1 && w.SlerpToRef(te, L, Math.max(0, T), L);
      } else {
        if ((i.onExit ?? "return") === "hold") {
          this._lastFrameTime = null, this._holdsTurn && ne(t, q);
          return;
        }
        if (this._settled) {
          this._lastFrameTime = null;
          return;
        }
        L.copyFrom(te);
      }
      const S = i.damping ?? 0;
      if (S > 0) {
        const A = performance.now(), x = this._lastFrameTime === null ? 0 : Math.min((A - this._lastFrameTime) / 1e3, 0.1);
        this._lastFrameTime = A;
        const T = 1 - Math.exp(-x / S);
        w.SlerpToRef(t.rotationQuaternion, L, T, t.rotationQuaternion);
      } else
        this._lastFrameTime = null, t.rotationQuaternion.copyFrom(L);
      this._holdsTurn = !0, b || Math.abs(w.Dot(t.rotationQuaternion, te)) > 1 - hs && (t.rotationQuaternion.copyFrom(te), this._settled = !0, this._holdsTurn = !1), ne(t, q);
    });
  }
  _removeBillboard() {
    this._observer && (this.sceneObject.babylonScene.onBeforeRenderObservable.remove(this._observer), this._observer = null), this._lastFrameTime = null, this._settled = !1, this._holdsTurn = !1, this._toggle.clearPending();
    const t = this.sceneObject.animationRoot;
    t && (t.rotationQuaternion = null, t.setPivotMatrix(Te.IdentityReadOnly));
  }
}, us = class extends R {
  static behaviorType = "ContentSlot";
  get layoutContentFit() {
    const t = this._resolved.fit ?? "contain", e = this._resolved.zooms;
    return e && e.length > 0 ? {
      fit: t,
      zooms: [...e]
    } : { fit: t };
  }
  validate(t) {
    const e = t.fit;
    if (e !== void 0 && e !== "contain" && e !== "scale-down" && e !== "none")
      return delete t.fit, [{
        field: "fit",
        message: "fit must be 'contain', 'scale-down' or 'none'",
        code: "INVALID_FIT"
      }];
    const s = t.zooms;
    return s !== void 0 && !(Array.isArray(s) && s.every((i) => typeof i == "number" && Number.isFinite(i) && i > 0)) ? (delete t.zooms, [{
      field: "zooms",
      message: "zooms must be a list of positive numbers",
      code: "INVALID_ZOOMS"
    }]) : [];
  }
  onAttach() {
    Q(this.sceneObject);
  }
  onDetach() {
    Q(this.sceneObject);
  }
  async applyCommit() {
    Q(this.sceneObject);
  }
}, et = new m(), ue = new m(), U = new m(), tt = new m(), se = new m(), ms = 0.25, fs = class extends R {
  static behaviorType = "Tether";
  _observer = null;
  _lastFrameTime = null;
  _outOfRangeSince = null;
  _targetObj = null;
  _toggle = new ze();
  setRuntimeEnabled(t) {
    this._toggle.set(t, this._observer !== null) && (this._lastFrameTime = null, this._outOfRangeSince = null);
  }
  isRuntimeEnabled() {
    return this._toggle.enabled;
  }
  onPlayModeChanged(t) {
    t ? this._applyTether() : this._removeTether();
  }
  onDetach() {
    this._removeTether();
  }
  async applyCommit(t) {
    this._removeTether(), this.playMode && this._applyTether();
  }
  _resolveAnchorObject() {
    const t = this._resolved.target ?? "";
    return t ? ((!this._targetObj || this._targetObj.transform.isDisposed()) && (this._targetObj = this.sceneObject.traceScene.resolveSceneObject(t, this.sceneObject)), this._targetObj) : null;
  }
  _resolveTargetPosition(t) {
    if (!(this._resolved.target ?? "")) {
      const s = this.sceneObject.babylonScene.activeCamera;
      return s ? (t.copyFrom(s.globalPosition), !0) : !1;
    }
    const e = this._resolveAnchorObject();
    return !e || e === this.sceneObject || e.transform.isDescendantOf(this.sceneObject.transform) ? !1 : (t.copyFrom(e.transform.getAbsolutePosition()), !0);
  }
  _applyTether() {
    const t = this.sceneObject.babylonScene;
    this._lastFrameTime = null, this._outOfRangeSince = null, this._targetObj = null, this._toggle.reset(this._resolved.enabled ?? !0), this._observer = t.onBeforeRenderObservable.add(() => {
      if (!this._toggle.enabled) return;
      const e = this._resolved, s = Math.max(0, e.keepDistance ?? 1), i = Math.max(0, e.speed ?? 1.5);
      if (i === 0 || !this._resolveTargetPosition(et)) return;
      const r = this.sceneObject.transform;
      r.computeWorldMatrix(!0), ue.copyFrom(r.getAbsolutePosition()), U.copyFrom(et).subtractInPlace(ue);
      const n = e.axes;
      n && (n.includes("x") || (U.x = 0), n.includes("y") || (U.y = 0), n.includes("z") || (U.z = 0));
      const a = U.length(), o = performance.now(), l = this._lastFrameTime === null ? 0 : Math.min((o - this._lastFrameTime) / 1e3, 0.1);
      this._lastFrameTime = o;
      const h = a > s, c = s > 0 && a < s * (1 - ms);
      if (h) {
        this._outOfRangeSince === null && (this._outOfRangeSince = o);
        const v = (e.delay ?? 0) * 1e3;
        if (o - this._outOfRangeSince < v) return;
      } else if (this._outOfRangeSince = null, !c) return;
      if (l === 0 || a < 1e-6) return;
      tt.copyFrom(U).scaleInPlace((a - s) / a);
      const u = e.damping ?? 0.25;
      se.copyFrom(tt), u > 0 && se.scaleInPlace(1 - Math.exp(-l / u));
      const _ = i * l, b = se.length();
      b > _ && se.scaleInPlace(_ / b), ue.addInPlace(se), r.setAbsolutePosition(ue);
    });
  }
  _removeTether() {
    this._observer && (this.sceneObject.babylonScene.onBeforeRenderObservable.remove(this._observer), this._observer = null), this._lastFrameTime = null, this._outOfRangeSince = null, this._targetObj = null, this._toggle.clearPending();
  }
}, ps = class extends R {
  static behaviorType = "MarkerSlot";
}, _s = class extends R {
  static behaviorType = "Model";
  get layoutFit() {
    const t = this._resolved.fit ?? "none";
    return t !== "cover" ? t : (this._warnedCoverClamp || (this._warnedCoverClamp = !0, y.warn(`[Model] "${this.sceneObject.name}": fit "cover" needs clipping the engine cannot do for a mesh — using "contain" so the model stays inside its slot.`)), "contain");
  }
  _warnedCoverClamp = !1;
  get layoutFitAnchor() {
    return this._resolved.fitAnchor === "bottom" ? "bottom" : "center";
  }
  validate(t) {
    const e = t.fit;
    if (e !== void 0 && e !== "fill" && e !== "contain" && e !== "scale-down" && e !== "cover" && e !== "none")
      return delete t.fit, [{
        field: "fit",
        message: "fit must be 'fill', 'contain', 'scale-down', 'cover' or 'none'",
        code: "INVALID_FIT"
      }];
    const s = t.fitAnchor;
    return s !== void 0 && s !== "center" && s !== "bottom" ? (delete t.fitAnchor, [{
      field: "fitAnchor",
      message: "fitAnchor must be 'center' or 'bottom'",
      code: "INVALID_FIT_ANCHOR"
    }]) : [];
  }
  _cachedSrcPath;
  extensionsUsed = [];
  khrDiagnostics = [];
  _modelRoot = null;
  _resetAssetTransform;
  constructor(t, e) {
    super(t, e), this.validate(this.getAuthored()), this._resolved = this._resolveAll(), this._resetAssetTransform = t._resetAssetTransform;
  }
  async load() {
    const t = this.sceneObject.src, e = this.sceneObject.name;
    if (y.debug(`[Model] Loading model ${e}`), !t) {
      y.debug(`[Model] No src specified for ${e}`);
      return;
    }
    if (this.sceneObject.isSceneReference && !this.sceneObject._standInFileSrc) {
      y.debug(`[Model] ${e}: "${t}" is a scene reference — the nested-scene load owns it`);
      return;
    }
    try {
      const s = (this.sceneObject._getBehaviorData() ?? []).some((n) => n["@type"] === "MorphStretch" || n["@type"] === "MeshBackground" || n["@type"] === "Bevel" || n["@type"] === "Renderer") || wt(this.sceneObject), i = await Xt(t, this.scene, this.resources, {
        parent: this.sceneObject.transform,
        resetTransform: this._resetAssetTransform,
        cloneMeshes: s
      });
      i.root.setEnabled(!1);
      const r = this.sceneObject.animationRoot;
      if (r && i.root.parent !== r && (i.root.parent = r), this._modelRoot = i.root, this._cachedSrcPath = i.containerPath || void 0, i.extensionsUsed && (this.extensionsUsed = i.extensionsUsed, this.sceneObject.extensionsUsed = i.extensionsUsed), this.khrDiagnostics = i.khrDiagnostics ?? [], i.instantiatedEntries && this.sceneObject.setAnimationClips(i.instantiatedEntries.animationGroups, `${e}_`), i.khrInteractivity && !this.sceneObject.getBehavior(ae)) {
        if (i.khrInteractivity.graphs.length > 1) {
          const { graphs: a, activeGraph: o } = Rt(i.khrInteractivity), l = a[o];
          l && l.nodes.length > 0 && await this.sceneObject.setBehavior(ae, {
            graphs: a,
            activeGraph: o
          });
        } else {
          const a = Ot(i.khrInteractivity);
          if (a.nodes.length > 0) {
            const o = Ct(a);
            await this.sceneObject.setBehavior(ae, o ? {
              graphs: o.graphs,
              activeGraph: o.activeGraph
            } : { graph: a });
          }
        }
        const n = this.sceneObject.getBehavior(ae);
        n && (n.khrManaged = !0, y.debug("[Model] Attached KHR-managed BehaviorGraph from KHR_interactivity"));
      }
      y.debug(`[Model] Successfully loaded ${e}`);
    } catch (s) {
      throw y.warn(`[Model] Failed to load ${e}: ${String(s)}`), s;
    }
  }
  onDetach() {
    this._modelRoot && (y.debug(`[Model] Disposing model root for ${this.sceneObject.name}`), this._modelRoot.dispose(!1, !1), this._modelRoot = null), this._cachedSrcPath && (this.resources.releaseContainer(this._cachedSrcPath), this._cachedSrcPath = void 0), Q(this.sceneObject);
  }
  getDimensions() {
    return this._measureLayoutBounds("parent")?.size ?? null;
  }
  get providesLayoutSize() {
    const t = this.sceneObject.src;
    if (typeof t == "string" && St(t)) return !1;
    const e = Tt(t);
    return e !== "bevel" && e !== "text";
  }
  layoutContentFrame = "parent";
  getLayoutContentSize() {
    for (const t of this.sceneObject.getBehaviors()) if (vt(t)) return null;
    return this._measureLayoutBounds("parent")?.size ?? null;
  }
  getLayoutIntrinsicSize() {
    return this._measureLayoutBounds("node")?.size ?? null;
  }
  getLayoutContentCenter() {
    return this._measureLayoutBounds("parent")?.center ?? null;
  }
  _measureLayoutBounds(t) {
    if (!this._modelRoot) return null;
    const e = t === "node" ? this.sceneObject.transform : this.sceneObject.transform.parent, s = e ? Te.Invert(e.computeWorldMatrix(!0)) : Te.Identity(), i = this._modelRoot.getChildMeshes(!1);
    this._modelRoot instanceof ts && i.push(this._modelRoot);
    const r = new m(1 / 0, 1 / 0, 1 / 0), n = new m(-1 / 0, -1 / 0, -1 / 0), a = new m();
    for (const h of i)
      if (h.getTotalVertices() !== 0) {
        h.computeWorldMatrix(!0);
        for (const c of h.getBoundingInfo().boundingBox.vectorsWorld)
          m.TransformCoordinatesToRef(c, s, a), r.minimizeInPlace(a), n.maximizeInPlace(a);
      }
    const o = {
      x: n.x - r.x,
      y: n.y - r.y,
      z: n.z - r.z
    };
    if (!isFinite(o.x) || !isFinite(o.y) || !isFinite(o.z) || o.x < 0 || o.y < 0 || o.z < 0) return null;
    const l = t === "node" ? m.Zero() : this.sceneObject.transform.position;
    return {
      size: o,
      center: {
        x: (r.x + n.x) / 2 - l.x,
        y: (r.y + n.y) / 2 - l.y,
        z: (r.z + n.z) / 2 - l.z
      }
    };
  }
  async applyCommit(t, e) {
    "fit" in t && Q(this.sceneObject);
  }
  onAttach(t) {
    y.debug(`[Model] Attaching to ${t.name}`), this._modelRoot && (this._modelRoot.setEnabled(!0), Q(this.sceneObject));
  }
}, bs = class extends R {
  static behaviorType = "Moveable";
  _dragToMove = null;
  _registeredForSelection = !1;
  _removeSelectionRegistration = null;
  onAttach() {
    const t = this.sceneObject.transform.getScene();
    this._dragToMove = new Yt(this.sceneObject.transform, t, {
      axes: this._resolved.axes,
      momentumDamping: this._resolved.momentumDamping,
      groundCircle: !1,
      onGrab: () => {
        this.sceneObject.traceScene.getRuntimeSelectionManager().select(this.sceneObject);
      }
    });
  }
  onPlayModeChanged(t) {
    this._dragToMove && (this._dragToMove.enabled = t), t ? this._registerForSelection() : (this._unregisterForSelection(), this._dragToMove?.setOptions({ groundCircle: !1 }));
  }
  onDetach() {
    this._unregisterForSelection(), this._dragToMove && (this._dragToMove.dispose(), this._dragToMove = null);
  }
  async applyCommit() {
    this._dragToMove && this._dragToMove.setOptions({
      axes: this._resolved.axes,
      momentumDamping: this._resolved.momentumDamping
    });
  }
  _registerForSelection() {
    this._registeredForSelection || (this._registeredForSelection = !0, this._removeSelectionRegistration = this.sceneObject.traceScene.getRuntimeSelectionManager().register(this.sceneObject, {
      onSelected: () => {
        (this.sceneObject.traceScene.getEventSystem()?.isXRActive?.() ?? !1) || this._dragToMove?.setOptions({ groundCircle: !0 });
      },
      onDeselected: () => {
        this._dragToMove?.setOptions({ groundCircle: !1 });
      }
    }));
  }
  _unregisterForSelection() {
    this._registeredForSelection && (this._registeredForSelection = !1, this._removeSelectionRegistration?.(), this._removeSelectionRegistration = null);
  }
}, gs = "data:image/png;base64,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", st = /* @__PURE__ */ (function(t) {
  return t.Constant = "Constant", t.Curve = "Curve", t.TwoConstants = "TwoConstants", t.TwoCurves = "TwoCurves", t;
})({}), X = /* @__PURE__ */ (function(t) {
  return t.Sphere = "Sphere", t.Hemisphere = "Hemisphere", t.Cone = "Cone", t.ConeVolume = "ConeVolume", t.Box = "Box", t.Rectangle = "Rectangle", t;
})({}), it = /* @__PURE__ */ (function(t) {
  return t.Color = "Color", t.Gradient = "Gradient", t.TwoColors = "TwoColors", t.TwoGradients = "TwoGradients", t;
})({}), N = /* @__PURE__ */ (function(t) {
  return t.Cone = "Cone", t.Sphere = "Sphere", t.Box = "Box", t;
})({}), ji = /* @__PURE__ */ (function(t) {
  return t.Additive = "Additive", t.Alpha = "Alpha", t.Premultiplied = "Premultiplied", t;
})({}), Fi = /* @__PURE__ */ (function(t) {
  return t.Additive = "Additive", t.Alpha = "Alpha", t;
})({}), B = {
  emissionRate: 10,
  maxParticles: 100,
  lifetime: {
    min: 1,
    max: 2
  },
  startColor: "#FFFFFFFF",
  startSpeed: {
    min: 1,
    max: 2
  },
  gravityModifier: 0,
  shape: {
    type: N.Cone,
    radius: 0.5,
    angle: 25
  },
  texture: ""
}, vs = 2, ys = 0.01;
function As(t, e, s) {
  const i = e > 0 ? e : vs, r = s > 0 ? s : ys;
  return Math.max(1, i / t / r);
}
var Ss = class j extends R {
  static behaviorType = "ParticleSystem";
  particleSystem = null;
  particleTexture = null;
  prewarmCycles;
  _loadedTextureSrc = "";
  noiseTexRef = null;
  _selectionMesh = null;
  _defaultUpdateFn = null;
  _scaleObserver = null;
  _lastScale = 1;
  _outgoing = null;
  static HANDOVER_MAX_FRAMES = 30;
  constructor(e, s) {
    super(e, s), this.prewarmCycles = e.config.prewarm ?? 0, this.isLegacyData(this.getAuthored()) && (this.migrateLegacyData(this.getAuthored()), this._resolved = this._resolveAll());
  }
  get data() {
    return this._resolved;
  }
  validate(e) {
    const s = [];
    return this.isLegacyData(e) && this.migrateLegacyData(e), (e.emissionRate === void 0 || e.emissionRate < 0) && s.push({
      field: "emissionRate",
      message: "emissionRate must be >= 0"
    }), (e.maxParticles === void 0 || e.maxParticles < 1) && s.push({
      field: "maxParticles",
      message: "maxParticles must be >= 1"
    }), (!e.lifetime || e.lifetime.min <= 0 || e.lifetime.max <= 0) && s.push({
      field: "lifetime",
      message: "lifetime min and max must be > 0"
    }), e.shape?.type || s.push({
      field: "shape.type",
      message: "shape.type is required"
    }), s;
  }
  isLegacyData(e) {
    const s = e;
    return s.emission?.rateOverTime !== void 0 || s.lifetime?.lifetimeAtStart !== void 0 || s.size?.sizeAtStart !== void 0;
  }
  migrateLegacyData(e) {
    y.debug("[ParticleSystem] Migrating legacy data format");
    const s = e.emission?.rateOverTime ?? B.emissionRate, i = e.emission?.maxParticleCount ?? B.maxParticles, r = this.convertMinMaxToRange(e.lifetime?.lifetimeAtStart, B.lifetime), n = this.convertLegacyShape(e.shape), a = this.convertMinMaxToRange(e.physicsData?.velocityAtStart, B.startSpeed), o = e.gravity?.gravityModifier ?? B.gravityModifier, l = e.texture?.src || B.texture;
    e.texture?.src && y.warn(`[ParticleSystem] Legacy particle texture "${e.texture.src}" is loaded as-is (not premultiplied); it may render incorrectly until re-imported through the editor.`);
    let h;
    if (e.size?.sizeOverLifetime?.customCurve) h = e.size.sizeOverLifetime.customCurve.map((d) => ({
      time: d.time,
      value: d.value
    }));
    else if (e.size?.sizeAtStart) {
      const d = this.convertMinMaxToRange(e.size.sizeAtStart, {
        min: 1,
        max: 1
      }), f = (d.min + d.max) / 2;
      h = [{
        time: 0,
        value: f
      }, {
        time: 1,
        value: f
      }];
    }
    const c = e.color?.colorAtStart, u = c ? this.convertLegacyColor(c) : B.startColor, _ = c?.mode === it.TwoColors && c.maxColor ? c.maxColor : void 0;
    let b;
    if (e.physicsData?.rotationAtStart) {
      const d = this.convertMinMaxToRange(e.physicsData.rotationAtStart, {
        min: 0,
        max: 0
      }), f = k.ToDegrees(d.min), g = k.ToDegrees(d.max);
      (f !== 0 || g !== 0) && (b = {
        min: f,
        max: g
      });
    }
    let v;
    if (e.physicsData?.angularVelocity) {
      const d = this.convertMinMaxToRange(e.physicsData.angularVelocity, {
        min: 0,
        max: 0
      }), f = k.ToDegrees(d.min), g = k.ToDegrees(d.max);
      (f !== 0 || g !== 0) && (v = {
        min: f,
        max: g
      });
    }
    let S;
    const A = e.noiseData ?? e.noiseData;
    if (A?.enabled) {
      const d = this.convertMinMaxToRange(A.strength, {
        min: 1,
        max: 1
      }), f = this.convertMinMaxToRange(A.strengthX, {
        min: d.min,
        max: d.max
      }), g = this.convertMinMaxToRange(A.strengthY, {
        min: d.min,
        max: d.max
      }), M = this.convertMinMaxToRange(A.strengthZ, {
        min: d.min,
        max: d.max
      }), C = 2;
      S = {
        strength: [
          f.max * C,
          g.max * C,
          M.max * C
        ],
        frequency: A.frequency ?? 0.5,
        octaves: A.octaves ?? 2,
        drag: 0.8
      };
    }
    const x = e;
    delete x.emission, delete x.size, delete x.color, delete x.physicsData, delete x.gravity, delete x.noiseData, delete x.noise, delete x.texture, delete x.lifetime, delete x.shape;
    const T = e;
    T["@type"] = "ParticleSystem", T.emissionRate = s, T.maxParticles = i, T.lifetime = r, T.startColor = u, _ && (T.startColor2 = _), T.startSpeed = a, T.gravityModifier = o, T.shape = n, T.texture = l, h && (T.sizeOverLifetime = h), b && (T.startRotation = b), v && (T.angularVelocity = v), S && (T.noise = S);
  }
  convertMinMaxToRange(e, s) {
    if (!e) return { ...s };
    switch (e.mode) {
      case st.Constant:
        return {
          min: e.constant ?? 1,
          max: e.constant ?? 1
        };
      case st.TwoConstants:
        return {
          min: e.minValue ?? 1,
          max: e.maxValue ?? 1
        };
      default:
        return e.constant !== void 0 ? {
          min: e.constant,
          max: e.constant
        } : { ...s };
    }
  }
  convertLegacyColor(e) {
    return e.mode === it.TwoColors ? e.minColor || B.startColor : e.color || B.startColor;
  }
  convertLegacyShape(e) {
    if (!e) return { ...B.shape };
    switch (e.type) {
      case X.Sphere:
      case X.Hemisphere:
        return {
          type: N.Sphere,
          radius: e.radius ?? 1
        };
      case X.Rectangle:
        return {
          type: N.Box,
          boxSize: [
            e.scale?.[0] ?? 1,
            e.scale?.[1] ?? 1,
            0
          ],
          emitDirection: [
            0,
            0,
            1
          ]
        };
      case X.Box:
        return {
          type: N.Box,
          boxSize: e.scale || [
            1,
            1,
            1
          ]
        };
      case X.Cone:
      case X.ConeVolume:
      default:
        return {
          type: N.Cone,
          radius: e.radius ?? 0.5,
          angle: e.angle ?? 25
        };
    }
  }
  async applyCommit(e, s) {
    const i = this._resolved.texture !== this._loadedTextureSrc, r = this.particleSystem != null && this._resolved.maxParticles !== s.maxParticles;
    if (i || r) {
      this.attachedNode && this._initAndStart(this.attachedNode, {
        capacityChanged: r,
        textureChanged: i
      });
      return;
    }
    this.particleSystem && this.applyAllProperties();
  }
  onAttach(e) {
    y.debug(`[ParticleSystem] Attaching to ${this.sceneObject.name}`), this._initAndStart(e), this.scene.onDisposeObservable.addOnce(() => {
      this.particleSystem?.dispose();
    });
  }
  _initAndStart(e, { capacityChanged: s = !1, textureChanged: i = !1 } = {}) {
    const r = s && !i && this.particleTexture != null;
    this.particleSystem && (r ? this._retireParticleSystem() : this._disposeParticleSystem()), this.initParticleSystem(), this.applyAllProperties(), r ? this._reuseTexture() : this.setupTexture();
    const n = s && this._prewarmToSteadyState();
    this.particleSystem.start(), n && this._resetPrewarmAfterStart(), this._createSelectionMesh(), this._lastScale = this.getHierarchyScale(), this._scaleObserver = e.onAfterWorldMatrixUpdateObservable.add(() => {
      const a = this.getHierarchyScale();
      Math.abs(a - this._lastScale) > 1e-3 && (this._lastScale = a, this.setupSize());
    });
  }
  onDetach() {
    this._scaleObserver && this.sceneObject.transform && (this.sceneObject.transform.onAfterWorldMatrixUpdateObservable.remove(this._scaleObserver), this._scaleObserver = null), this._disposeParticleSystem(), y.debug(`[ParticleSystem] ${this.sceneObject.name} detached and cleaned up`);
  }
  _createSelectionMesh() {
    this._disposeSelectionMesh();
    const e = this.attachedNode;
    if (!e) return;
    const s = this.data.shape, i = `${this.sceneObject.name}${Gt}`, r = this.sceneObject.babylonScene, n = 0.3;
    switch (s.type) {
      case N.Box: {
        const a = s.boxSize ?? [
          1,
          1,
          1
        ];
        this._selectionMesh = Ae.CreateBox(i, {
          width: Math.max(a[0], n),
          height: Math.max(a[1], n),
          depth: Math.max(a[2], n)
        }, r);
        break;
      }
      case N.Sphere: {
        const a = Math.max(s.radius ?? 0.5, n / 2);
        this._selectionMesh = Ae.CreateSphere(i, {
          diameter: a * 2,
          segments: 8
        }, r);
        break;
      }
      case N.Cone: {
        const a = Math.max(s.radius ?? 0.5, n / 2);
        this._selectionMesh = Ae.CreateSphere(i, {
          diameter: a * 2,
          segments: 8
        }, r);
        break;
      }
    }
    this._selectionMesh && (this._selectionMesh.parent = e, this._selectionMesh.visibility = 0, this._selectionMesh.isPickable = !0);
  }
  _disposeSelectionMesh() {
    this._selectionMesh && (this._selectionMesh.dispose(), this._selectionMesh = null);
  }
  _disposeParticleSystem() {
    this._disposeOutgoing(), this._releaseSystemAttachments(), this.particleSystem && (this.particleSystem.stop(), this.particleSystem.dispose(), this.particleSystem = null), this.particleTexture && (this.particleTexture.dispose(), this.particleTexture = null), this.noiseTexRef && (this.noiseTexRef.dispose(), this.noiseTexRef = null);
  }
  _retireParticleSystem() {
    const e = this.particleSystem, s = this.noiseTexRef;
    if (this.particleSystem = null, this.noiseTexRef = null, this._releaseSystemAttachments(), e.stop(), this._outgoing && !e.isReady()) {
      j._disposeSharingTexture(e, s);
      return;
    }
    this._disposeOutgoing();
    let i = 0;
    const r = this.scene.onBeforeRenderObservable.add(() => {
      (this.particleSystem?.isReady() || ++i > j.HANDOVER_MAX_FRAMES) && this._disposeOutgoing();
    });
    this._outgoing = {
      system: e,
      noise: s,
      observer: r
    };
  }
  _disposeOutgoing() {
    const e = this._outgoing;
    e && (this._outgoing = null, this.scene.onBeforeRenderObservable.remove(e.observer), j._disposeSharingTexture(e.system, e.noise));
  }
  static _disposeSharingTexture(e, s) {
    e.stop(), e.dispose(!1), s?.dispose();
  }
  _releaseSystemAttachments() {
    this._scaleObserver && this.sceneObject.transform && (this.sceneObject.transform.onAfterWorldMatrixUpdateObservable.remove(this._scaleObserver), this._scaleObserver = null), this._defaultUpdateFn = null, this._disposeSelectionMesh();
  }
  initParticleSystem() {
    this.particleSystem = new ns(`particles_${this.sceneObject.name}`, this.data.maxParticles, this.scene), this.particleSystem.preWarmCycles = this.prewarmCycles, this.particleSystem.emitter = this.sceneObject.transform;
  }
  _reuseTexture() {
    const e = this.particleSystem;
    e.particleTexture = this.particleTexture, e.blendMode = We.ALPHA_PREMULTIPLIED_PORTERDUFF;
  }
  static CAPACITY_REBUILD_PREWARM_STEPS = 120;
  static CAPACITY_REBUILD_PREWARM_MIN_STEPS = 8;
  static CAPACITY_REBUILD_PREWARM_REFERENCE_POPULATION = 150;
  _prewarmToSteadyState() {
    const e = this.particleSystem;
    if (e.noiseTexture) return !1;
    const s = Math.max(0, this.data.lifetime.max), i = Math.min(this.data.maxParticles, this.data.emissionRate * s), r = i > j.CAPACITY_REBUILD_PREWARM_REFERENCE_POPULATION ? Math.max(j.CAPACITY_REBUILD_PREWARM_MIN_STEPS, Math.round(j.CAPACITY_REBUILD_PREWARM_STEPS * j.CAPACITY_REBUILD_PREWARM_REFERENCE_POPULATION / i)) : j.CAPACITY_REBUILD_PREWARM_STEPS;
    return e.preWarmCycles = r, e.preWarmStepOffset = As(r, this.data.lifetime.max, e.updateSpeed), !0;
  }
  _resetPrewarmAfterStart() {
    const e = this.particleSystem;
    e.preWarmCycles = this.prewarmCycles, e.preWarmStepOffset = 1;
  }
  applyAllProperties() {
    this.particleSystem && (this.setupEmission(), this.setupLifetime(), this.setupSize(), this.setupColor(), this.setupSpeed(), this.setupGravity(), this.setupRotation(), this.setupShape(), this.setupNoise());
  }
  setupEmission() {
    this.particleSystem.emitRate = this.data.emissionRate;
  }
  setupLifetime() {
    this.particleSystem.minLifeTime = this.data.lifetime.min, this.particleSystem.maxLifeTime = this.data.lifetime.max;
  }
  setupSize() {
    const e = this.particleSystem, s = this.getHierarchyScale(), i = this.data.particleScale ?? 1;
    if (e.getSizeGradients()) {
      const r = e.getSizeGradients();
      for (; r.length > 0; ) e.removeSizeGradient(r[0].gradient);
    }
    if (this.data.sizeOverLifetime && this.data.sizeOverLifetime.length > 0) for (const r of this.data.sizeOverLifetime) e.addSizeGradient(r.time, r.value * i * s);
    else
      e.minSize = 1 * i * s, e.maxSize = 1 * i * s;
  }
  setupColor() {
    const e = this.particleSystem, s = z.FromHexString(this.ensureAlpha(this.data.startColor)), i = this.data.startColor2 ? z.FromHexString(this.ensureAlpha(this.data.startColor2)) : s.clone();
    e.color1 = new z(s.r * s.a, s.g * s.a, s.b * s.a, s.a), e.color2 = new z(i.r * i.a, i.g * i.a, i.b * i.a, i.a);
    const r = this.data.endColor ? z.FromHexString(this.ensureAlpha(this.data.endColor)) : new z(0, 0, 0, 0);
    e.colorDead = new z(r.r * r.a, r.g * r.a, r.b * r.a, r.a);
  }
  ensureAlpha(e) {
    return e.length === 7 ? e + "FF" : e;
  }
  setupSpeed() {
    this.particleSystem.minEmitPower = this.data.startSpeed.min, this.particleSystem.maxEmitPower = this.data.startSpeed.max;
  }
  setupGravity() {
    this.particleSystem.gravity = new m(0, this.data.gravityModifier * -9.8, 0);
  }
  setupRotation() {
    const e = this.particleSystem;
    this.data.startRotation ? (e.minInitialRotation = k.ToRadians(this.data.startRotation.min), e.maxInitialRotation = k.ToRadians(this.data.startRotation.max)) : (e.minInitialRotation = 0, e.maxInitialRotation = 0), this.data.angularVelocity ? (e.minAngularSpeed = k.ToRadians(this.data.angularVelocity.min), e.maxAngularSpeed = k.ToRadians(this.data.angularVelocity.max)) : (e.minAngularSpeed = 0, e.maxAngularSpeed = 0);
  }
  setupShape() {
    const e = this.particleSystem, s = this.data.shape, i = e.particleEmitterType;
    switch (s.type) {
      case N.Sphere:
        i instanceof Ye ? i.radius = s.radius ?? 1 : e.particleEmitterType = new Ye(s.radius ?? 1);
        break;
      case N.Cone:
        i instanceof Pe ? (i.radius = s.radius ?? 0.5, i.angle = k.ToRadians(s.angle ?? 25)) : e.particleEmitterType = new Pe(s.radius ?? 0.5, k.ToRadians(s.angle ?? 25));
        break;
      case N.Box: {
        const r = s.boxSize ?? [
          1,
          1,
          1
        ], n = [
          r[0] / 2,
          r[1] / 2,
          r[2] / 2
        ], a = s.emitDirection ?? [
          0,
          1,
          0
        ];
        if (i instanceof we)
          i.minEmitBox.set(-n[0], -n[1], -n[2]), i.maxEmitBox.set(n[0], n[1], n[2]), i.direction1.set(a[0], a[1], a[2]), i.direction2.set(a[0], a[1], a[2]);
        else {
          const o = new we();
          o.minEmitBox = new m(-n[0], -n[1], -n[2]), o.maxEmitBox = new m(n[0], n[1], n[2]), o.direction1 = new m(a[0], a[1], a[2]), o.direction2 = new m(a[0], a[1], a[2]), e.particleEmitterType = o;
        }
        break;
      }
    }
    e.particleEmitterType !== i && (e.particleEmitterType instanceof Pe ? this.wrapConeEmitter(e.particleEmitterType) : e.particleEmitterType instanceof we || this.wrapEmitterDirection(e.particleEmitterType));
  }
  wrapEmitterDirection(e) {
    const s = e.startDirectionFunction.bind(e), i = new m(), r = this.particleSystem;
    e.startDirectionFunction = (n, a, o, l, h) => {
      const c = o.position.x, u = o.position.y, _ = o.position.z;
      m.TransformCoordinatesToRef(o.position, r._emitterInverseWorldMatrix, i);
      const b = n.m[12], v = n.m[13], S = n.m[14];
      o.position.set(i.x + b, i.y + v, i.z + S), s(n, a, o, l, h), o.position.set(c, u, _);
    };
  }
  wrapConeEmitter(e) {
    e.startPositionFunction = (s, i, r, n) => {
      const a = Math.random() * Math.PI * 2, o = e.radius * Math.sqrt(Math.random()), l = o * Math.cos(a), h = o * Math.sin(a);
      if (n) {
        i.set(l, 0, h);
        return;
      }
      m.TransformCoordinatesFromFloatsToRef(l, 0, h, s, i);
    }, e.startDirectionFunction = (s, i, r, n) => {
      const a = e.angle / 2, o = Math.random() * Math.PI * 2, l = 1 - Math.random() * (1 - Math.cos(a)), h = Math.sqrt(1 - l * l), c = h * Math.cos(o), u = l, _ = h * Math.sin(o);
      if (n) {
        i.set(c, u, _);
        return;
      }
      m.TransformNormalFromFloatsToRef(c, u, _, s, i);
    };
  }
  setupNoise() {
    const e = this.particleSystem, s = this.data.noise;
    if (!s || s.strength[0] === 0 && s.strength[1] === 0 && s.strength[2] === 0) {
      this.noiseTexRef && (e.noiseTexture = null, this.noiseTexRef.dispose(), this.noiseTexRef = null), this._defaultUpdateFn && (e.updateFunction = this._defaultUpdateFn);
      return;
    }
    this.noiseTexRef || (this.noiseTexRef = new as(`noise_${this.sceneObject.name}`, 256, this.scene)), this.noiseTexRef.octaves = s.octaves ?? 2, this.noiseTexRef.animationSpeedFactor = (s.frequency ?? 0.5) * 4, this.noiseTexRef.brightness = 0.5, this.noiseTexRef.persistence = 0.7, e.noiseTexture = this.noiseTexRef, e.noiseStrength = new m(s.strength[0], s.strength[1], s.strength[2]), this._defaultUpdateFn || (this._defaultUpdateFn = e.updateFunction);
    const i = s.drag ?? 0;
    if (i > 0) {
      const r = this._defaultUpdateFn;
      let n = new Float32Array(e.getCapacity()), a = new Float32Array(e.getCapacity()), o = new Float32Array(e.getCapacity());
      e.updateFunction = (l) => {
        l.length > n.length && (n = new Float32Array(l.length), a = new Float32Array(l.length), o = new Float32Array(l.length));
        for (let c = 0; c < l.length; c++)
          n[c] = l[c].direction.x, a[c] = l[c].direction.y, o[c] = l[c].direction.z;
        r(l);
        const h = Math.pow(1 - i, e._scaledUpdateSpeed);
        for (let c = 0; c < l.length; c++) {
          const u = l[c];
          u.direction.x = n[c] + (u.direction.x - n[c]) * h, u.direction.y = a[c] + (u.direction.y - a[c]) * h, u.direction.z = o[c] + (u.direction.z - o[c]) * h;
        }
      };
    } else e.updateFunction = this._defaultUpdateFn;
  }
  setupTexture() {
    const e = this.particleSystem, s = this.data.texture;
    this._loadedTextureSrc = s;
    const i = s ? this.resources.getAsset(s) : void 0;
    if (i) {
      const r = URL.createObjectURL(i);
      this.particleTexture = new ce(r, this.scene, !1, !0, ce.TRILINEAR_SAMPLINGMODE, () => {
        URL.revokeObjectURL(r);
      });
    } else if (s) {
      const r = this.resources.resolveAssetUrl(s) ?? s;
      this.particleTexture = new ce(r, this.scene, !1, !0);
    } else this.particleTexture = new ce(gs, this.scene);
    e.particleTexture = this.particleTexture, e.blendMode = We.ALPHA_PREMULTIPLIED_PORTERDUFF;
  }
  getHierarchyScale() {
    if (!this.sceneObject.transform) return 1;
    const e = this.sceneObject.transform.scaling;
    return (e.x + e.y + e.z) / 3;
  }
}, Ts = class extends R {
  static behaviorType = "Provenance";
  static literalData = !0;
}, xs = class extends R {
  static behaviorType = "AiSession";
}, Os = class extends R {
  static behaviorType = "RestRelativeBinding";
  async applyCommit() {
    this.sceneObject.animationBinding?.sources?.length && await Nt(this.sceneObject);
  }
}, Rs = class extends R {
  static behaviorType = "RecordingInfo";
  static literalData = !0;
}, rt = 0.01, me = 0.035, nt = 4 * Math.PI, ws = Math.PI / 12, Ps = Math.PI / 4;
function Ee(t, e) {
  return Math.round(t / e) * e;
}
function at(t, e, s, i, r, n, a, o) {
  if (i && i.length > 0) {
    const _ = m.Right(), b = m.Up(), v = m.Forward();
    _.rotateByQuaternionToRef(t, _), b.rotateByQuaternionToRef(t, b), v.rotateByQuaternionToRef(t, v);
    const S = [];
    i.includes("x") && S.push(_), i.includes("y") && S.push(b), i.includes("z") && S.push(v);
    let A = t.clone();
    for (const x of S) {
      const T = m.Dot(x, r), d = m.Dot(x, n);
      let f = T * s + d * e;
      o !== void 0 && (f = Ee(f, o)), A = w.RotationAxis(x, f).multiply(A);
    }
    return A;
  }
  let l = e, h = s;
  o !== void 0 && (l = Ee(l, o), h = Ee(h, o));
  const c = w.RotationAxis(m.Up(), h), u = w.RotationAxis(a, l);
  return c.multiply(u).multiply(t);
}
var Me = null, Ie = /* @__PURE__ */ new Map(), Cs = class {
  onDragStartObservable = new Xe();
  onDragEndObservable = new Xe();
  _target;
  _scene;
  _options;
  _enabled = !1;
  _disposed = !1;
  _pointerObserver = null;
  _sceneDisposeObserver = null;
  _isDragging = !1;
  _dragPointerId = null;
  _lastPointerX = 0;
  _lastPointerY = 0;
  _dragStartQuat = null;
  _accumX = 0;
  _accumY = 0;
  _velX = new qe();
  _velY = new qe();
  _glideObserver = null;
  _glide = null;
  constructor(t, e, s) {
    this._target = t, this._scene = e, this._options = { ...s }, Le(this._target);
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(t) {
    this._disposed || t === this._enabled || (this._enabled = t, t ? this._activate() : this._deactivate());
  }
  setOptions(t) {
    this._options = {
      ...this._options,
      ...t
    };
  }
  dispose() {
    this._disposed || (this._disposed = !0, this._enabled = !1, this._deactivate(), this.onDragStartObservable.clear(), this.onDragEndObservable.clear());
  }
  _activate() {
    Ie.set(this._target, this), this._setupPointerObserver(), this._sceneDisposeObserver = this._scene.onDisposeObservable.addOnce(() => {
      this.dispose();
    });
  }
  _deactivate() {
    Ie.delete(this._target), this._endDrag(), this._cancelGlide(), this._teardownPointerObserver(), this._sceneDisposeObserver && (this._scene.onDisposeObservable.remove(this._sceneDisposeObserver), this._sceneDisposeObserver = null);
  }
  _setupPointerObserver() {
    this._pointerObserver || (this._pointerObserver = this._scene.onPointerObservable.add((t) => {
      switch (t.type) {
        case Oe.POINTERDOWN: {
          if (t.event.button !== 0 || this._isDragging || Me) return;
          const e = t.pickInfo;
          if (!e?.hit || !e.pickedMesh) return;
          this._isMeshOfTarget(e.pickedMesh) && this._startDrag(t);
          break;
        }
        case Oe.POINTERMOVE:
          if (!this._isDragging || this._getPointerId(t) !== this._dragPointerId) return;
          this._updateDrag(t);
          break;
        case Oe.POINTERUP:
          if (!this._isDragging || this._getPointerId(t) !== this._dragPointerId) return;
          this._endDrag();
          break;
      }
    }));
  }
  _teardownPointerObserver() {
    this._pointerObserver && (this._scene.onPointerObservable.remove(this._pointerObserver), this._pointerObserver = null);
  }
  _getPointerId(t) {
    return t.event.pointerId ?? 0;
  }
  _startDrag(t) {
    if (Le(this._target), this._cancelGlide(), this._dragStartQuat = this._target.rotationQuaternion.clone(), this._lastPointerX = t.event.clientX, this._lastPointerY = t.event.clientY, this._accumX = 0, this._accumY = 0, this._velX.reset(), this._velY.reset(), this._momentumEnabled()) {
      const e = performance.now();
      this._velX.push(0, e), this._velY.push(0, e);
    }
    this._dragPointerId = this._getPointerId(t), this._isDragging = !0, Me = this, this._detachCamera(), this._options.onGrab?.(), this.onDragStartObservable.notifyObservers();
  }
  _updateDrag(t) {
    if (!this._dragStartQuat) return;
    const e = t.event.clientX - this._lastPointerX, s = t.event.clientY - this._lastPointerY;
    if (this._lastPointerX = t.event.clientX, this._lastPointerY = t.event.clientY, this._accumY += e * rt, this._accumX += s * rt, this._momentumEnabled()) {
      const a = performance.now();
      this._velX.push(this._accumX, a), this._velY.push(this._accumY, a);
    }
    let i;
    this._options.snap && t.event.altKey && (i = t.event.shiftKey ? Ps : ws);
    const { camUp: r, camRight: n } = this._getCameraDirections();
    this._target.rotationQuaternion = at(this._dragStartQuat, this._accumX, this._accumY, this._options.axes, r, n, this._getRightAxis(), i);
  }
  _getCameraDirections() {
    const t = this._scene.activeCamera;
    if (!t) return {
      camUp: m.Up(),
      camRight: m.Right()
    };
    const e = t.getWorldMatrix(), s = m.TransformNormal(m.Up(), e), i = m.TransformNormal(m.Right(), e);
    return s.normalize(), i.normalize(), {
      camUp: s,
      camRight: i
    };
  }
  _getRightAxis() {
    const t = this._scene.activeCamera;
    let e = m.Right();
    if (t) {
      const s = t.getWorldMatrix();
      e = m.TransformNormal(m.Right(), s), e.y = 0;
      const i = e.length();
      i > 1e-3 ? e.scaleInPlace(1 / i) : e = m.Right();
    }
    return e;
  }
  _endDrag() {
    this._isDragging && (this._maybeStartGlide(), this._isDragging = !1, Me = null, this._dragStartQuat = null, this._dragPointerId = null, this._accumX = 0, this._accumY = 0, this._reattachCamera(), this.onDragEndObservable.notifyObservers());
  }
  _momentumEnabled() {
    const t = this._options.momentumDamping ?? 0;
    return Number.isFinite(t) && t > 0;
  }
  _maybeStartGlide() {
    if (!this._momentumEnabled() || !this._dragStartQuat) return;
    const t = performance.now(), e = (r) => Math.max(-nt, Math.min(nt, r)), s = e(this._velX.velocity(t)), i = e(this._velY.velocity(t));
    Math.abs(s) < me && Math.abs(i) < me || this._startGlideWithRates(s, i, t);
  }
  _startGlideWithRates(t, e, s) {
    if (!this._dragStartQuat) return;
    this._cancelGlide();
    const { camUp: i, camRight: r } = this._getCameraDirections(), n = this._getRightAxis();
    this._glide = {
      startQuat: this._dragStartQuat.clone(),
      accumX0: this._accumX,
      accumY0: this._accumY,
      vx: t,
      vy: e,
      tau: this._options.momentumDamping ?? 0,
      startTime: s,
      axes: this._options.axes ? [...this._options.axes] : void 0,
      camUp: i.clone(),
      camRight: r.clone(),
      rightAxis: n.clone()
    }, this._glideObserver = this._scene.onBeforeRenderObservable.add(() => this._glideStep());
  }
  _glideStep() {
    const t = this._glide;
    if (!t) return;
    const e = (performance.now() - t.startTime) / 1e3, s = Math.abs(Ze(t.vx, t.tau, e)) < me && Math.abs(Ze(t.vy, t.tau, e)) < me, i = t.accumX0 + Ue(t.vx, t.tau, e), r = t.accumY0 + Ue(t.vy, t.tau, e);
    this._target.rotationQuaternion = at(t.startQuat, i, r, t.axes, t.camUp, t.camRight, t.rightAxis), s && this._cancelGlide();
  }
  _cancelGlide() {
    this._glideObserver && (this._scene.onBeforeRenderObservable.remove(this._glideObserver), this._glideObserver = null), this._glide = null;
  }
  _detachCamera() {
    const t = this._scene.activeCamera;
    t && t.detachControl();
  }
  _reattachCamera() {
    const t = this._scene.activeCamera, e = this._scene.getEngine().getRenderingCanvas();
    t && e && t.attachControl(e, !0);
  }
  _isMeshOfTarget(t) {
    let e = t;
    for (; e; ) {
      if (Ie.has(e)) return e === this._target;
      e = e.parent;
    }
    return !1;
  }
}, Es = class extends R {
  static behaviorType = "Rotatable";
  _dragToRotate = null;
  _registeredForSelection = !1;
  _removeSelectionRegistration = null;
  onAttach() {
    const t = this.sceneObject.transform.getScene();
    this._dragToRotate = new Cs(this.sceneObject.transform, t, {
      axes: this._resolved.axes,
      momentumDamping: this._resolved.momentumDamping,
      onGrab: () => {
        this.sceneObject.traceScene.getRuntimeSelectionManager().select(this.sceneObject);
      }
    });
  }
  onPlayModeChanged(t) {
    this._dragToRotate && (this._dragToRotate.enabled = t), t ? this._registerForSelection() : this._unregisterForSelection();
  }
  onDetach() {
    this._unregisterForSelection(), this._dragToRotate && (this._dragToRotate.dispose(), this._dragToRotate = null);
  }
  async applyCommit() {
    this._dragToRotate && this._dragToRotate.setOptions({
      axes: this._resolved.axes,
      momentumDamping: this._resolved.momentumDamping
    });
  }
  _registerForSelection() {
    this._registeredForSelection || (this._registeredForSelection = !0, this._removeSelectionRegistration = this.sceneObject.traceScene.getRuntimeSelectionManager().register(this.sceneObject, {
      onSelected: () => {
      },
      onDeselected: () => {
      }
    }));
  }
  _unregisterForSelection() {
    this._registeredForSelection && (this._registeredForSelection = !1, this._removeSelectionRegistration?.(), this._removeSelectionRegistration = null);
  }
}, Ms = Math.PI / 180, Ve = new m();
function Is(t) {
  switch (t) {
    case "x":
      return m.Right();
    case "y":
      return m.Up();
    case "z":
      return m.Forward();
    case "Random":
      return new m(Math.random() * 2 - 1, Math.random() * 2 - 1, Math.random() * 2 - 1).normalize();
    default:
      return m.Up();
  }
}
function ot(t, e) {
  if (e <= 0) return t;
  const s = (Math.random() * 2 - 1) * e;
  return Math.max(0, t + s);
}
var Vs = class extends R {
  static behaviorType = "Rotate";
  _renderObserver = null;
  _runtimeAxis = m.Up();
  _runtimeSpeed = 90;
  _pivoted = !1;
  onDetach() {
    this._stopRotation();
    const t = this.sceneObject.animationRoot;
    t && xe(t, "[Rotate]");
  }
  onPlayModeChanged(t) {
    t ? this._startRotation() : this._stopRotation();
  }
  async applyCommit(t) {
    if (t.axis === void 0 && this._renderObserver && this.playMode) {
      const e = this._resolved.speed ?? 90, s = this._resolved.speedRange ?? 0;
      this._runtimeSpeed = ot(e, s);
      return;
    }
    this._stopRotation(), this.playMode && this._startRotation();
  }
  _startRotation() {
    if (!this.scene) return;
    this._renderObserver && this._stopRotation();
    const t = this.sceneObject.getOrCreateAnimationRoot();
    xe(t, "[Rotate]");
    const e = this._resolved.axis ?? "y", s = this._resolved.speed ?? 90, i = this._resolved.speedRange ?? 0;
    this._runtimeAxis = Is(e), this._runtimeSpeed = ot(s, i), t.rotationQuaternion || (t.rotationQuaternion = w.Identity()), this._renderObserver = this.scene.onBeforeRenderObservable.add(() => {
      if (!this.scene) return;
      const r = this.scene.getEngine().getDeltaTime() / 1e3, n = this._runtimeSpeed * Ms * r, a = w.RotationAxis(this._runtimeAxis, n);
      t.rotationQuaternion.multiplyInPlace(a);
      const o = t.parent;
      o ? o.getWorldMatrix().decompose(Ve) : Ve.setAll(1), ne(t, Ve), this._pivoted = !0;
    });
  }
  _stopRotation() {
    this._renderObserver && this.scene && (this.scene.onBeforeRenderObservable.remove(this._renderObserver), this._renderObserver = null);
    const t = this.sceneObject.animationRoot;
    t && (xe(t, "[Rotate]"), this._pivoted && t.setPivotMatrix(Te.IdentityReadOnly)), this._pivoted = !1;
  }
};
var Ns = 0.1;
function fe(t) {
  J(t) && t.isSampling() || ft(t) && t.isPlaying() || t.play();
}
function pe(t, e) {
  J(t) ? t.sampleAt(e) : t.seek(e);
}
var _e = -1, ks = class Se extends R {
  static behaviorType = "Timeline";
  _currentTime = 0;
  _playing = !1;
  _renderObserver = null;
  _restObserver = null;
  _placedSampled = /* @__PURE__ */ new WeakSet();
  _firedKeyframes = /* @__PURE__ */ new Set();
  _clockCache = null;
  _playablesCache = null;
  _clockWarned = /* @__PURE__ */ new Set();
  _cueApplied = /* @__PURE__ */ new Map();
  _cueTargets = /* @__PURE__ */ new Map();
  _cueTargetsRevision = NaN;
  getTime() {
    return this._currentTime;
  }
  getDuration() {
    return this._resolved.duration ?? 10;
  }
  isPlaying() {
    return this._playing;
  }
  play() {
    if (!this._playing) {
      this._currentTime >= this.getDuration() && (this._currentTime = 0, this._firedKeyframes.clear()), this._playing = !0, this._clockCache = null, this._playablesCache = null, this._startRenderLoop(), this._applyStateCues(this._currentTime, !0);
      for (const e of this._getPlayables())
        pe(e, this._currentTime), fe(e);
    }
  }
  pause() {
    if (this._playing) {
      this._playing = !1, this._stopRenderLoop();
      for (const e of this._getPlayables()) e.pause();
    }
  }
  stop() {
    this.pause(), this.seek(0);
  }
  seek(e, s = "absolute") {
    const i = this.getDuration(), r = s === "relative" ? this._currentTime + e : e, n = Math.max(0, Math.min(r, i));
    n < this._currentTime && this._firedKeyframes.clear(), this._currentTime = n, this._applyStateCues(n, !0);
    for (const a of this._getPlayables())
      pe(a, this._currentTime), this._playing && fe(a);
  }
  onPlayModeChanged(e) {
    if (e)
      this._currentTime = 0, this._firedKeyframes.clear(), this._applyStateCues(0, !0), this._startRestWatch(), this._placeNewSampled(), this._resolved.playOnStart !== !1 && this.play();
    else {
      this._stopRestWatch(), this._playing = !1, this._stopRenderLoop(), this._currentTime = 0, this._firedKeyframes.clear();
      for (const s of this._getPlayables()) s.stop();
      this._releaseCues();
    }
  }
  onDetach() {
    this._stopRestWatch(), this._stopRenderLoop(), this._releaseCues();
  }
  async applyCommit(e, s) {
    const i = this.getAuthored(), r = (n) => n in e || JSON.stringify(s[n]) !== JSON.stringify(i[n]);
    if (r("clock") && (this._clockCache = null, this._playablesCache = null), r("keyframes")) {
      const n = this._cueApplied.size > 0;
      this._releaseCues(), this._cueTargets.clear(), n && this._applyStateCues(this._currentTime, !0);
    }
    if (e.duration !== void 0 && this._currentTime > e.duration) {
      this._currentTime = e.duration;
      for (const n of this._getPlayables()) pe(n, this._currentTime);
    }
  }
  _structureRevision() {
    const e = this.sceneObject.traceScene.structureRevision;
    return typeof e == "number" ? e : NaN;
  }
  _getPlayables() {
    const e = this._structureRevision(), s = this._playablesCache;
    if (s && s.rev === e) return s.list;
    const i = [];
    this._collectPlayables(this.sceneObject, i);
    const r = this._getClock();
    return r && He(r) && !i.includes(r) && i.push(r), this._playablesCache = Number.isNaN(e) ? null : {
      rev: e,
      list: i
    }, i;
  }
  _collectPlayables(e, s) {
    for (const i of e.getBehaviors()) i !== this && !(i instanceof Se) && He(i) && s.push(i);
    for (const i of e.getChildren())
      i.getBehaviors().some((r) => r instanceof Se) || this._collectPlayables(i, s);
  }
  _getClock() {
    const e = this._resolved.clock;
    if (!e) return null;
    const s = this._structureRevision(), i = this._clockCache;
    if (i && i.path === e && i.rev === s) return i.clock;
    const r = this._resolveClock(e);
    return this._clockCache = Number.isNaN(s) && !r ? null : {
      path: e,
      rev: s,
      clock: r
    }, r;
  }
  _resolveClock(e) {
    const s = this.sceneObject.traceScene.resolveSceneObject(e, this.sceneObject);
    if (s) {
      for (const i of s.getBehaviors()) if (i !== this && !(i instanceof Se) && Dt(i)) return i;
    }
    return this._clockWarned.has(e) || (this._clockWarned.add(e), y.warn(s ? `[Timeline] clock "${e}" has no clock-capable Playable (AudioClip/Video) — advancing on scene time` : `[Timeline] clock "${e}" not found — advancing on scene time`)), null;
  }
  _startRenderLoop() {
    this._renderObserver || (this._renderObserver = this.scene.onBeforeAnimationsObservable.add(() => {
      if (!this._playing) return;
      const e = this.scene.getEngine().getDeltaTime() / 1e3, s = this._resolved.speed ?? 1, i = this.getDuration();
      if (i <= 0) return;
      const r = this._currentTime, n = s === 1 ? this._getClock() : null, a = n ? n.getClockTime() : null;
      let o = !1;
      if (a !== null && Number.isFinite(a)) if (Math.abs(a - r) > 0.25)
        this._currentTime = a, o = !0;
      else {
        const l = r + e;
        this._currentTime = l + (a - l) * Math.min(1, e / Ns);
      }
      else this._currentTime += e * s;
      if (o && this._currentTime < r ? this._firedKeyframes.clear() : this._checkKeyframes(r, this._currentTime), o) {
        const l = Math.max(0, Math.min(this._currentTime, i));
        for (const h of this._getPlayables())
          h === n || J(h) || (h.seek(l), fe(h));
      }
      if (this._currentTime >= i) if (this._resolved.loop) {
        this._currentTime = this._currentTime % i, this._firedKeyframes.clear(), this._checkKeyframes(0, this._currentTime), this._applyStateCues(this._currentTime, !0);
        for (const l of this._getPlayables())
          pe(l, this._currentTime), fe(l);
      } else {
        this._currentTime = i, this._playing = !1, this._stopRenderLoop(), this._applyStateCues(this._currentTime);
        for (const l of this._getPlayables()) J(l) && l.isSampling() ? l.sampleAt(i) : l.stop();
      }
      else {
        this._applyStateCues(this._currentTime);
        for (const l of this._getPlayables()) J(l) && l.isSampling() && l.sampleAt(this._currentTime);
      }
    }));
  }
  _placeNewSampled() {
    for (const e of this._getPlayables())
      if (!(!J(e) || this._placedSampled.has(e))) {
        if (e.isSampling() || ft(e) && e.isPlaying()) {
          this._placedSampled.add(e);
          continue;
        }
        e.sampleAt(this._currentTime), e.isSampling() && this._placedSampled.add(e);
      }
  }
  _startRestWatch() {
    this._restObserver || !this.scene || (this._restObserver = this.scene.onBeforeAnimationsObservable.add(() => this._placeNewSampled()));
  }
  _stopRestWatch() {
    this._restObserver && this.scene && this.scene.onBeforeAnimationsObservable.remove(this._restObserver), this._restObserver = null, this._placedSampled = /* @__PURE__ */ new WeakSet();
  }
  _stopRenderLoop() {
    this._renderObserver && this.scene && (this.scene.onBeforeAnimationsObservable.remove(this._renderObserver), this._renderObserver = null);
  }
  _checkKeyframes(e, s) {
    const i = this._resolved.keyframes;
    if (i?.length)
      for (let r = 0; r < i.length; r++) {
        if (this._firedKeyframes.has(r)) continue;
        const n = i[r];
        n.time >= e && n.time <= s && (this._firedKeyframes.add(r), n.event && this._fireKeyframeEvent(n.event, n.target));
      }
  }
  _resolveCueTarget(e) {
    const s = this._structureRevision();
    if (s !== this._cueTargetsRevision) {
      this._cueTargets.clear(), this._cueTargetsRevision = s;
      for (const a of this._cueApplied.keys()) a.transform.isDisposed() && this._cueApplied.delete(a);
    }
    const i = e.target ?? "", r = this._cueTargets.get(i);
    if (r) return r;
    const n = e.target ? this.sceneObject.traceScene.resolveSceneObject(e.target, this.sceneObject) : this.sceneObject;
    return n && this._cueTargets.set(i, n), n ?? null;
  }
  _applyStateCues(e, s = !1) {
    const i = this._resolved.keyframes;
    if (!i?.length) return;
    const r = /* @__PURE__ */ new Map();
    for (let n = 0; n < i.length; n++) {
      const a = i[n];
      if (typeof a.active != "boolean") continue;
      const o = this._resolveCueTarget(a);
      if (!o) continue;
      const l = r.get(o) ?? _e;
      a.time <= e && (l === _e || i[l].time <= a.time) ? r.set(o, n) : r.has(o) || r.set(o, _e);
    }
    for (const [n, a] of r)
      !s && this._cueApplied.get(n) === a || (this._cueApplied.set(n, a), n.setActiveCue(a === _e ? void 0 : i[a].active === !0));
  }
  _releaseCues() {
    for (const e of this._cueApplied.keys()) e.setActiveCue(void 0);
    this._cueApplied.clear();
  }
  _fireKeyframeEvent(e, s) {
    const i = this.sceneObject.traceScene, r = s ? i.resolveSceneObject(s, this.sceneObject) : this.sceneObject;
    if (!r) {
      y.warn(`[Timeline] Keyframe target not found: ${s}`);
      return;
    }
    for (const n of r.getBehaviors()) n instanceof It && n.fireEvent(e).catch((a) => {
      y.error(`[Timeline] Keyframe event "${e}" failed:`, a);
    });
  }
}, K = new m(), ie = new m(), W = new m(), re = new m(), be = new m(), Ne = new m(), ke = new m(), H = new m(), G = new m(), lt = new m(), ct = new w(), ht = 0.25, Bs = 30, js = 0.05, Fs = class extends R {
  static behaviorType = "ViewAnchor";
  _observer = null;
  _lastFrameTime = null;
  _outOfRangeSince = null;
  _anchorObj = null;
  _toggle = new ze();
  _engaged = !1;
  setRuntimeEnabled(t) {
    this._toggle.set(t, this._observer !== null) && (this._lastFrameTime = null, this._outOfRangeSince = null, this._engaged = !1);
  }
  isRuntimeEnabled() {
    return this._toggle.enabled;
  }
  onPlayModeChanged(t) {
    t ? this._applyViewAnchor() : this._removeViewAnchor();
  }
  onDetach() {
    this._removeViewAnchor();
  }
  async applyCommit(t) {
    this._removeViewAnchor(), this.playMode && this._applyViewAnchor();
  }
  _resolveAnchorObject() {
    const t = this._resolved.target ?? "";
    return t ? ((!this._anchorObj || this._anchorObj.transform.isDisposed()) && (this._anchorObj = this.sceneObject.traceScene.resolveSceneObject(t, this.sceneObject)), this._anchorObj) : null;
  }
  _resolveViewAnchor(t, e, s) {
    const i = this._resolved.target ?? "", r = this.sceneObject.babylonScene;
    if (i) {
      const u = this._resolveAnchorObject();
      if (!u || u === this.sceneObject || u.transform.isDescendantOf(this.sceneObject.transform)) return !1;
      t.copyFrom(u.transform.getAbsolutePosition()), u.transform.getWorldMatrix().decompose(void 0, ct, void 0), e.set(0, 0, 1), e.applyRotationQuaternionToRef(ct, e);
    } else {
      const u = r.activeCamera;
      if (!u) return !1;
      t.copyFrom(u.globalPosition), lt.set(0, 0, r.useRightHandedSystem ? -1 : 1), u.getDirectionToRef(lt, e);
    }
    const n = Math.sqrt(e.x * e.x + e.z * e.z);
    if (n < 0.05) return !1;
    const a = e.x / n, o = e.z / n, l = Bs * (Math.PI / 180), h = Math.max(-l, Math.min(l, Math.atan2(e.y, n))), c = Math.cos(h);
    return e.set(a * c, Math.sin(h), o * c), r.useRightHandedSystem ? s.set(-o, 0, a) : s.set(o, 0, -a), !0;
  }
  _applyViewAnchor() {
    const t = this.sceneObject.babylonScene;
    this._lastFrameTime = null, this._outOfRangeSince = null, this._anchorObj = null, this._engaged = !1, this._toggle.reset(this._resolved.enabled ?? !0), this._observer = t.onBeforeRenderObservable.add(() => {
      if (!this._toggle.enabled) return;
      const e = this._resolved, s = Math.max(0, e.speed ?? 1.5);
      if (s === 0 || !this._resolveViewAnchor(ke, be, Ne)) return;
      const i = e.forward ?? 1, r = e.lateral ?? 0;
      K.copyFrom(ke), K.x += be.x * i + Ne.x * r, K.y += be.y * i + (e.vertical ?? 0), K.z += be.z * i + Ne.z * r;
      const n = this.sceneObject.transform;
      n.computeWorldMatrix(!0), ie.copyFrom(n.getAbsolutePosition()), W.copyFrom(K).subtractInPlace(ie);
      const a = e.axes;
      a && (a.includes("x") || (W.x = 0), a.includes("y") || (W.y = 0), a.includes("z") || (W.z = 0));
      const o = W.length(), l = performance.now(), h = this._lastFrameTime === null ? 0 : Math.min((l - this._lastFrameTime) / 1e3, 0.1);
      if (this._lastFrameTime = l, !this._updateViewEngagement(l, o, K, ke, ie) || h === 0 || o < 1e-6) return;
      const c = e.damping ?? 0.25;
      re.copyFrom(W), c > 0 && re.scaleInPlace(1 - Math.exp(-h / c));
      const u = s * h, _ = re.length();
      _ > u && re.scaleInPlace(u / _), ie.addInPlace(re), n.setAbsolutePosition(ie);
    });
  }
  _updateViewEngagement(t, e, s, i, r) {
    const n = this._resolved;
    H.copyFrom(s).subtractInPlace(i);
    const a = H.length();
    if (this._engaged)
      return e <= Math.max(js, a * 0.02) ? (this._engaged = !1, this._outOfRangeSince = null, !1) : !0;
    G.copyFrom(r).subtractInPlace(i);
    const o = G.length();
    let l = 0;
    if (o > 1e-4 && a > 1e-4) {
      const v = Math.min(1, Math.max(-1, m.Dot(G, H) / (o * a)));
      l = Math.acos(v) * 180 / Math.PI;
    }
    const h = Math.sqrt(G.x * G.x + G.z * G.z), c = Math.sqrt(H.x * H.x + H.z * H.z), u = c > 1e-4 && h > c * (1 + ht), _ = c > 1e-4 && h < c * (1 - ht);
    if (!(l > (n.viewAngle ?? 20) || u || _))
      return this._outOfRangeSince = null, !1;
    this._outOfRangeSince === null && (this._outOfRangeSince = t);
    const b = (n.delay ?? 0) * 1e3;
    return t - this._outOfRangeSince < b ? !1 : (this._engaged = !0, !0);
  }
  _removeViewAnchor() {
    this._observer && (this.sceneObject.babylonScene.onBeforeRenderObservable.remove(this._observer), this._observer = null), this._lastFrameTime = null, this._outOfRangeSince = null, this._anchorObj = null, this._engaged = !1, this._toggle.clearPending();
  }
}, dt = !1;
function pt() {
  if (dt) return 0;
  dt = !0;
  let t = 0;
  const e = (s) => {
    t++, bt(s);
  };
  return e(Bt), e(Ft), e(Be), e(os), e(cs), e(ae), e(ds), e(Zt), e(us), e(fs), e(Kt), e(Jt), e($t), e(At), e(yt), e(ps), e(_s), e(bs), e(Fe), e(ye), e(Ss), e(I), e(Ts), e(xs), e(Os), e(Rs), e(Et), e(Es), e(Vs), e(Ht), e(zt), e(Qt), e(Wt), e(Mt), e(es), e(ks), e(je), e(Fs), t;
}
pt();
function Ds() {
  return pt();
}
var Di = `
interface Vec3 {
    x: number;
    y: number;
    z: number;
}

interface BehaviorData {
    '@type': string;
}

interface ScriptContext<TData extends BehaviorData = BehaviorData> {
    /** This behavior's serialized data (typed per-script) */
    readonly data: Readonly<TData>;
    /** The object this script is attached to */
    readonly self: SceneObjectHandle;
    /** Scene-level queries */
    readonly scene: SceneHandle;
    /** Frame timing */
    readonly time: Time;
    /** Logging (scripts cannot use console directly) */
    readonly log: Log;
}

interface SceneObjectHandle {
    readonly name: string;
    readonly path: string;
    active: boolean;

    // Transform (read/write, euler degrees)
    position: Vec3;
    rotation: Vec3;
    scale: Vec3;
    readonly worldPosition: Vec3;

    // Hierarchy
    getParent(): SceneObjectHandle | null;
    getChildren(): SceneObjectHandle[];
    findChild(name: string): SceneObjectHandle | null;

    // Properties
    getProp(name: string): string | number | boolean | Vec3 | undefined;

    // Behaviors (access other scripts/behaviors on this object)
    getBehavior<T extends BehaviorData>(type: string): BehaviorHandle<T> | null;
    /**
     * Add or update a behavior on this object.
     * If the behavior already exists, merges overrides into its data and commits.
     * If it doesn't exist, adds it with the given overrides.
     *
     * @param type - Behavior @type string (e.g. "Text", "Rotate", "Renderer")
     * @param overrides - Partial data to set (excluding @type)
     */
    setBehavior(type: string, overrides: Record<string, unknown>): void;

    // Actions (imperative — trigger behavior methods, not data commits)
    playAnimation(clip: string, opts?: { speed?: number; loop?: boolean }): void;
    stopAnimation(): void;
    playNote(note: number, opts?: { duration?: number; volume?: number }): void;
    playFrequency(freq: number, opts?: { duration?: number; volume?: number }): void;
    stopSynth(): void;
    setColor(color: string, materialIndex?: number): void;

    // Events
    dispatch(eventName: string): void;
}

interface BehaviorHandle<TData extends BehaviorData = BehaviorData> {
    readonly type: string;
    readonly data: Readonly<TData>;
}

interface SceneHandle {
    find(pathOrName: string): SceneObjectHandle | null;
    readonly isPlaying: boolean;

    // Camera (read-only)
    readonly cameraPosition: Vec3;
    readonly cameraForward: Vec3;
}

interface Time {
    /** Seconds since last frame */
    readonly deltaTime: number;
    /** Seconds since script started */
    readonly elapsed: number;
}

interface Log {
    info(...args: unknown[]): void;
    warn(...args: unknown[]): void;
    error(...args: unknown[]): void;
}

type EaseType =
    | 'linear'
    | 'easeInQuad' | 'easeOutQuad' | 'easeInOutQuad'
    | 'easeInCubic' | 'easeOutCubic' | 'easeInOutCubic'
    | 'easeOutBack' | 'easeInBack';

interface Vec3Static {
    add(a: Vec3, b: Vec3): Vec3;
    subtract(a: Vec3, b: Vec3): Vec3;
    scale(v: Vec3, s: number): Vec3;
    dot(a: Vec3, b: Vec3): number;
    cross(a: Vec3, b: Vec3): Vec3;
    length(v: Vec3): number;
    normalize(v: Vec3): Vec3;
    lerp(a: Vec3, b: Vec3, t: number): Vec3;
    distance(a: Vec3, b: Vec3): number;
    zero(): Vec3;
    one(): Vec3;
    up(): Vec3;
    forward(): Vec3;
    right(): Vec3;
}

interface MathUtilStatic {
    clamp(value: number, min: number, max: number): number;
    lerp(a: number, b: number, t: number): number;
    inverseLerp(a: number, b: number, value: number): number;
    remap(value: number, fromMin: number, fromMax: number, toMin: number, toMax: number): number;
    degToRad(degrees: number): number;
    radToDeg(radians: number): number;
    random(min: number, max: number): number;
    randomInt(min: number, max: number): number;
}
`, ge = {
  "||": 1,
  "&&": 2,
  "==": 3,
  "!=": 3,
  "<": 4,
  "<=": 4,
  ">": 4,
  ">=": 4,
  "+": 5,
  "-": 5,
  "*": 6,
  "/": 6,
  "**": 7
}, zs = {
  "+": "add",
  "-": "sub",
  "*": "mul",
  "/": "div",
  "**": "pow",
  "<": "lt",
  "<=": "le",
  ">": "gt",
  ">=": "ge",
  "==": "eq",
  "&&": "and",
  "||": "or"
}, Y = (t) => ({
  type: typeof t,
  literal: t
}), V = (t, e, s) => ({
  op: `math/${t}`,
  type: e,
  inputs: s
});
function D(t, e) {
  if (t.type !== e) throw new Error(`Expected ${e}, received ${t.type}`);
}
function Ls(t, e, s, i) {
  if (typeof e != "string" || !e.trim() || e.length > 2048) throw new Error("Expression must contain 1–2048 characters");
  const r = [], n = /\s*(\d+(?:\.\d*)?(?:[eE][+-]?\d+)?|\.\d+(?:[eE][+-]?\d+)?|"(?:[^"\\]|\\.)*"|[A-Za-z_][A-Za-z_0-9]*|\*\*|<=|>=|==|!=|&&|\|\||[()+\-*/<>,!?:])/y;
  let a = 0;
  for (; a < e.trimEnd().length; ) {
    n.lastIndex = a;
    const d = n.exec(e);
    if (!d) throw new Error(`Invalid expression syntax at character ${a + 1}`);
    if (r.push(d[1]), a = n.lastIndex, r.length > 256) throw new Error("Expression exceeds 256 tokens");
  }
  let o = 0, l = 0;
  const h = () => r[o++], c = (d) => r[o] === d ? (o++, !0) : !1, u = (d) => {
    if (!c(d)) throw new Error(`Expected "${d}" at token ${o + 1}`);
  };
  function _(d) {
    for (let f = s; f; f = f.getParent()) {
      const g = f.getBehavior(I)?.getProperty(d);
      if (g) {
        if (![
          "number",
          "boolean",
          "string"
        ].includes(g.type)) throw new Error(`Property "${d}" has unsupported expression type ${g.type}`);
        return {
          type: g.type,
          property: d
        };
      }
    }
    throw new Error(`No declared property "${d}" in scope "${s.name}" or its ancestors`);
  }
  function b() {
    const d = h();
    if (d === "(") {
      const f = v();
      return u(")"), f;
    }
    if (d === "!" || d === "-" || d === "+") {
      const f = v(7);
      return D(f, d === "!" ? "boolean" : "number"), d === "!" ? V("not", "boolean", { a: f }) : d === "-" ? V("sub", "number", {
        a: Y(0),
        b: f
      }) : f;
    }
    if (d?.startsWith('"')) try {
      return Y(JSON.parse(d));
    } catch {
      throw new Error(`Invalid string literal ${d} at token ${o}`);
    }
    if (d === "true" || d === "false") return Y(d === "true");
    if (d && /^[\d.]/.test(d)) {
      const f = Number(d);
      if (!Number.isFinite(f)) throw new Error("Numeric literals must be finite");
      return Y(f);
    }
    if (d && /^[A-Za-z_]/.test(d)) {
      if (!c("(")) return _(d);
      const f = [];
      if (!c(")")) {
        do
          f.push(v());
        while (c(","));
        u(")");
      }
      const g = {
        min: 2,
        max: 2,
        pow: 2,
        floor: 1,
        abs: 1,
        clamp: 3
      };
      if (!Object.hasOwn(g, d) || f.length !== g[d]) throw new Error(`Supported functions: min(a,b), max(a,b), pow(a,b), floor(x), abs(x), clamp(min,x,max); invalid call to ${d}`);
      return f.forEach((M) => D(M, "number")), d === "clamp" ? V("min", "number", {
        a: V("max", "number", {
          a: f[0],
          b: f[1]
        }),
        b: f[2]
      }) : d === "abs" ? V("max", "number", {
        a: f[0],
        b: V("sub", "number", {
          a: Y(0),
          b: f[0]
        })
      }) : V(d, "number", {
        a: f[0],
        ...f[1] ? { b: f[1] } : {}
      });
    }
    throw new Error(`Expected a value at token ${o}`);
  }
  function v(d = 0) {
    if (++l > 32) throw new Error("Expression nesting exceeds 32");
    let f = b();
    for (; Object.hasOwn(ge, r[o]) && ge[r[o]] >= d; ) {
      const g = h(), M = v(ge[g] + (g === "**" ? 0 : 1)), C = g === "==" || g === "!=", Z = g === "&&" || g === "||";
      C || D(f, Z ? "boolean" : "number"), D(M, f.type), f = g === "!=" ? V("not", "boolean", { a: V("eq", "boolean", {
        a: f,
        b: M
      }) }) : V(zs[g], C || Z || ge[g] === 4 ? "boolean" : "number", {
        a: f,
        b: M
      });
    }
    if (d === 0 && c("?")) {
      D(f, "boolean");
      const g = v();
      u(":");
      const M = v();
      D(M, g.type), f = V("select", g.type, {
        condition: f,
        a: g,
        b: M
      });
    }
    return l--, f;
  }
  const S = v();
  if (o !== r.length) throw new Error(`Unexpected token "${r[o]}"`);
  i && D(S, i);
  const A = /* @__PURE__ */ new Map(), x = /* @__PURE__ */ new Map();
  function T(d) {
    const f = A.get(d);
    if (f !== void 0) return f;
    if (d.property) {
      let C = x.get(d.property);
      return C === void 0 && (C = t.addGetPropertyNode(s, d.property), x.set(d.property, C)), A.set(d, C), C;
    }
    const g = t._addNode(d.op ?? "math/select", {});
    A.set(d, g);
    const M = d.inputs ?? {
      condition: Y(!0),
      a: d,
      b: d
    };
    for (const [C, Z] of Object.entries(M)) Z.literal !== void 0 ? t._setValue(g, C, Z.literal) : t._setValueRef(g, C, T(Z), "value");
    return g;
  }
  return {
    node: T(S),
    socket: "value",
    type: S.type
  };
}
var ut = [
  "bool",
  "float",
  "string",
  "float3",
  "float4",
  "float2"
], zi = class {
  _nodes = [];
  _variables = [];
  _events = [];
  _x = 0;
  _context;
  constructor(t) {
    this._context = t;
  }
  expression(t, e = this._context, s) {
    return Ls(this, t, e, s);
  }
  _targetPath(t) {
    return this._context.traceScene.getRelativePath(t, this._context);
  }
  onSelect(t) {
    return this._addEventNode(p.EVENT_ON_SELECT, t);
  }
  onStart(t) {
    return this._addEventNode(p.EVENT_ON_START, t);
  }
  onHover(t) {
    const e = this._addNode(p.EVENT_ON_HOVER_IN, {}, t), s = this._addNode(p.EVENT_ON_HOVER_OUT, {});
    return new Zs(this, e, s);
  }
  onProximity(t, e, s) {
    const i = this._addNode(p.TRACE_ON_PROXIMITY, { target: [this._targetPath(t)] }, s);
    return this._setValue(i, "threshold", e), new qs(this, i);
  }
  onTick() {
    return this._addEventNode(p.EVENT_ON_TICK);
  }
  onStateChange(t) {
    const e = this._addNode(p.TRACE_ON_STATE_CHANGE, { target: [this._targetPath(t)] });
    return new P(this, e, "out");
  }
  addGetPropertyNode(t, e) {
    return this._addNode(p.TRACE_GET_PROPERTY, {
      target: [this._targetPath(t)],
      property: [e]
    });
  }
  addGetStateNode(t) {
    return this._addNode(p.TRACE_GET_STATE, { target: [this._targetPath(t)] });
  }
  addTimeNode() {
    return this._addNode(p.TRACE_TIME, {});
  }
  addPagesGetActiveIndexNode(t) {
    return this._addNode(p.PAGES_GET_ACTIVE_INDEX, { target: [this._targetPath(t)] });
  }
  addPagesGetPageCountNode(t) {
    return this._addNode(p.PAGES_GET_PAGE_COUNT, { target: [this._targetPath(t)] });
  }
  addGetPositionNode(t) {
    return this._addNode(p.POINTER_GET, {
      target: [this._targetPath(t)],
      property: ["translation"]
    });
  }
  addGetRotationNode(t) {
    return this._addNode(p.POINTER_GET, {
      target: [this._targetPath(t)],
      property: ["rotation"]
    });
  }
  addGetScaleNode(t) {
    return this._addNode(p.POINTER_GET, {
      target: [this._targetPath(t)],
      property: ["scale"]
    });
  }
  addGetActiveNode(t) {
    return this._addNode(p.TRACE_GET_ACTIVE, { target: [this._targetPath(t)] });
  }
  addGetChildCountNode(t) {
    return this._addNode(p.TRACE_GET_CHILD_COUNT, { target: [this._targetPath(t)] });
  }
  addNotNode(t, e = "value") {
    const s = this._addNode(p.MATH_NOT, {});
    return this._setValueRef(s, "a", t, e), s;
  }
  addFloorNode(t, e = "value") {
    const s = this._addNode(p.MATH_FLOOR, {});
    return this._setValueRef(s, "a", t, e), s;
  }
  addRandomNode(t = 0, e = 1) {
    const s = this._addNode(p.MATH_RANDOM, {});
    return typeof t == "number" ? this._setValue(s, "min", t) : this._setValueRef(s, "min", t.node, t.socket), typeof e == "number" ? this._setValue(s, "max", e) : this._setValueRef(s, "max", e.node, e.socket), s;
  }
  addCombine3Node(t, e, s, i = "value") {
    const r = this._addNode(p.MATH_COMBINE3, {});
    return this._setValueRef(r, "a", t, i), this._setValueRef(r, "b", e, i), this._setValueRef(r, "c", s, i), r;
  }
  addVariable(t, e) {
    const s = this._variables.length;
    return this._variables.push({
      name: t,
      type: 1,
      value: [e]
    }), s;
  }
  flowFrom(t, e) {
    if (t < 0 || t >= this._nodes.length) throw new RangeError(`flowFrom: nodeIndex ${t} out of range [0, ${this._nodes.length})`);
    return new P(this, t, e);
  }
  build() {
    const t = /* @__PURE__ */ new Map(), e = [];
    for (const o of this._nodes) t.has(o.op) || (t.set(o.op, e.length), e.push({ op: o.op }));
    const s = ut, i = this._nodes.map((o) => {
      const l = t.get(o.op) ?? 0, h = {};
      for (const [_, b] of Object.entries(o.config)) {
        const v = b[0];
        h[_] = {
          type: typeof v == "boolean" ? 0 : typeof v == "number" ? 1 : 2,
          value: b
        };
      }
      const c = {};
      for (const [_, b] of Object.entries(o.values)) c[_] = b;
      const u = {};
      for (const [_, b] of Object.entries(o.flows)) u[_] = b;
      return {
        declaration: l,
        ...Object.keys(h).length > 0 ? { configuration: h } : {},
        ...Object.keys(c).length > 0 ? { values: c } : {},
        ...Object.keys(u).length > 0 ? { flows: u } : {},
        metadata: {
          ...o.metadata,
          x: o.x,
          y: o.y
        }
      };
    }), r = /* @__PURE__ */ new Set();
    for (const o of i) if (o.values)
      for (const l of Object.values(o.values)) "type" in l && r.add(l.type);
    for (const o of this._variables) r.add(o.type);
    const n = [...r].sort((o, l) => o - l), a = /* @__PURE__ */ new Map();
    n.forEach((o, l) => a.set(o, l));
    for (const o of i) {
      if (o.configuration) for (const l of Object.values(o.configuration)) l.type = a.get(l.type) ?? 0;
      if (o.values)
        for (const l of Object.values(o.values)) "type" in l && (l.type = a.get(l.type) ?? 0);
    }
    return {
      types: n.map((o) => ({ signature: s[o] })),
      declarations: e,
      variables: this._variables.map((o) => ({
        ...o,
        type: a.get(o.type) ?? 0
      })),
      events: this._events.map((o) => ({ ...o })),
      nodes: i
    };
  }
  _addNode(t, e, s) {
    const i = this._nodes.length;
    return this._nodes.push({
      op: t,
      config: e,
      values: {},
      flows: {},
      x: this._x,
      y: 0,
      ...s ? { metadata: s } : {}
    }), this._x += 250, i;
  }
  _setFlow(t, e, s, i = "in") {
    this._nodes[t].flows[e] = {
      node: s,
      socket: i
    };
  }
  _setValue(t, e, s) {
    const i = typeof s == "boolean" ? 0 : typeof s == "number" ? 1 : 2;
    this._nodes[t].values[e] = {
      type: i,
      value: [s]
    };
  }
  _setValueVec2(t, e, s) {
    this._nodes[t].values[e] = {
      type: 5,
      value: [...s]
    };
  }
  _setValueVec3(t, e, s) {
    this._nodes[t].values[e] = {
      type: 3,
      value: [...s]
    };
  }
  _setValueVec4(t, e, s) {
    this._nodes[t].values[e] = {
      type: 4,
      value: [...s]
    };
  }
  _setValueRef(t, e, s, i) {
    this._nodes[t].values[e] = {
      node: s,
      socket: i
    };
  }
  _addVariable(t, e, s) {
    const i = ut.indexOf(e);
    if (i === -1) throw new Error(`GraphBuilder: unsupported variable type ${e}`);
    return this._variables.push({
      name: t,
      type: i,
      value: [s]
    }), this._variables.length - 1;
  }
  _addEvent() {
    return this._events.push({ id: "" }), this._events.length - 1;
  }
  _setNodeY(t, e) {
    this._nodes[t].y = e;
  }
  _addEventNode(t, e) {
    const s = this._addNode(t, {}, e);
    return new P(this, s, "out");
  }
}, P = class O {
  _builder;
  _prevNode;
  _prevSocket;
  constructor(e, s, i) {
    this._builder = e, this._prevNode = s, this._prevSocket = i;
  }
  toggleActive(e) {
    const { nodes: s } = kt(this._builder, xt, { [Vt]: this._builder._targetPath(e) });
    return this._wire(s.set), new O(this._builder, s.set, "out");
  }
  setActive(e, s) {
    const i = this._builder._addNode(p.TRACE_SET_ACTIVE, { target: [this._builder._targetPath(e)] });
    return this._builder._setValue(i, "state", s), this._wire(i), new O(this._builder, i, "out");
  }
  setBehaviorEnabled(e, s, i) {
    const r = this._builder._addNode(p.TRACE_SET_BEHAVIOR_ENABLED, {
      target: [this._builder._targetPath(e)],
      behavior: [s]
    });
    return this._builder._setValue(r, "enabled", i), this._wire(r), new O(this._builder, r, "out");
  }
  playAnimation(e, s, i) {
    const r = { target: [this._builder._targetPath(e)] };
    s && (r.clip = [s]);
    const n = this._builder._addNode(p.TRACE_PLAY_ANIMATION, r);
    return i?.loop && this._builder._setValue(n, "loop", !0), i?.speed !== void 0 && this._builder._setValue(n, "speed", i.speed), this._wire(n), new mt(this._builder, n);
  }
  playAnimationExternal(e, s, i, r) {
    const n = {
      target: [this._builder._targetPath(e)],
      src: [s]
    };
    i && (n.clip = [i]);
    const a = this._builder._addNode(p.TRACE_PLAY_ANIMATION_EXTERNAL, n);
    return r?.loop && this._builder._setValue(a, "loop", !0), r?.speed !== void 0 && this._builder._setValue(a, "speed", r.speed), this._wire(a), new mt(this._builder, a);
  }
  playVideo(e, s) {
    const i = this._builder._addNode(p.TRACE_PLAY_VIDEO, { target: [this._builder._targetPath(e)] });
    return s?.play !== void 0 && this._builder._setValue(i, "play", s.play), s?.volume !== void 0 && this._builder._setValue(i, "volume", s.volume), s?.seek !== void 0 && this._builder._setValue(i, "seek", s.seek), this._wire(i), new O(this._builder, i, "out");
  }
  playMedia(e, s) {
    const i = this._builder._addNode(p.TRACE_PLAY_MEDIA, { target: [this._builder._targetPath(e)] });
    return s?.src !== void 0 && this._builder._setValue(i, "src", s.src), s?.volume !== void 0 && this._builder._setValue(i, "volume", s.volume), s?.seek !== void 0 && this._builder._setValue(i, "seek", s.seek), this._wire(i), new O(this._builder, i, "out");
  }
  pauseMedia(e) {
    const s = this._builder._addNode(p.TRACE_PAUSE_MEDIA, { target: [this._builder._targetPath(e)] });
    return this._wire(s), new O(this._builder, s, "out");
  }
  stopMedia(e) {
    const s = this._builder._addNode(p.TRACE_STOP_MEDIA, { target: [this._builder._targetPath(e)] });
    return this._wire(s), new O(this._builder, s, "out");
  }
  seekMedia(e, s) {
    const i = this._builder._addNode(p.TRACE_SEEK_MEDIA, { target: [this._builder._targetPath(e)] });
    return this._builder._setValue(i, "time", s), this._wire(i), new O(this._builder, i, "out");
  }
  setMediaVolume(e, s) {
    const i = this._builder._addNode(p.TRACE_SET_MEDIA_VOLUME, { target: [this._builder._targetPath(e)] });
    return this._builder._setValue(i, "volume", s), this._wire(i), new O(this._builder, i, "out");
  }
  navigate(e) {
    const s = this._builder._addNode(p.TRACE_NAVIGATE, {});
    return this._builder._setValue(s, "url", e), this._wire(s), new O(this._builder, s, "out");
  }
  setActiveChild(e, s) {
    const i = this._builder._addNode(p.TRACE_SET_ACTIVE_CHILD, { target: [this._builder._targetPath(e)] });
    return this._builder._setValue(i, "index", s), this._wire(i), new O(this._builder, i, "out");
  }
  pagesNext(e, s = !0, i = !1) {
    const r = this._builder._addNode(p.PAGES_NEXT, { target: [this._builder._targetPath(e)] });
    return this._builder._setValue(r, "wrap", s), this._builder._setValue(r, "animate", i), this._wire(r), new O(this._builder, r, "out");
  }
  pagesPrev(e, s = !0, i = !1) {
    const r = this._builder._addNode(p.PAGES_PREV, { target: [this._builder._targetPath(e)] });
    return this._builder._setValue(r, "wrap", s), this._builder._setValue(r, "animate", i), this._wire(r), new O(this._builder, r, "out");
  }
  _transformWrite(e, s, i, r) {
    const n = {
      target: [this._builder._targetPath(e)],
      property: [s]
    }, a = r ? this._builder._addNode(p.POINTER_INTERPOLATE, n) : this._builder._addNode(p.POINTER_SET, n);
    if (i(a), r) {
      const [o, l, h, c] = jt(r.easing);
      this._builder._setValue(a, "duration", r.duration), this._builder._setValueVec2(a, "p1", [o, l]), this._builder._setValueVec2(a, "p2", [h, c]);
    }
    return this._wire(a), new O(this._builder, a, "out");
  }
  setPosition(e, s, i) {
    return this._transformWrite(e, "translation", (r) => this._builder._setValueVec3(r, "value", s), i);
  }
  setPositionFrom(e, s, i = "value", r) {
    return this._transformWrite(e, "translation", (n) => this._builder._setValueRef(n, "value", s, i), r);
  }
  setRotation(e, s, i) {
    return this._transformWrite(e, "rotation", (r) => this._builder._setValueVec4(r, "value", s), i);
  }
  setRotationFrom(e, s, i = "value", r) {
    return this._transformWrite(e, "rotation", (n) => this._builder._setValueRef(n, "value", s, i), r);
  }
  setScale(e, s, i) {
    return this._transformWrite(e, "scale", (r) => this._builder._setValueVec3(r, "value", s), i);
  }
  setScaleFrom(e, s, i = "value", r) {
    return this._transformWrite(e, "scale", (n) => this._builder._setValueRef(n, "value", s, i), r);
  }
  setProperty(e, s, i, r) {
    const n = this._builder._addNode(p.TRACE_SET_PROPERTY, {
      target: [this._builder._targetPath(e)],
      property: [s],
      ...r ? { transition: [r] } : {}
    });
    return this._builder._setValue(n, "value", i), this._wire(n), new O(this._builder, n, "out");
  }
  setPropertyFrom(e, s, i, r = "value", n) {
    const a = this._builder._addNode(p.TRACE_SET_PROPERTY, {
      target: [this._builder._targetPath(e)],
      property: [s],
      ...n ? { transition: [n] } : {}
    });
    return this._builder._setValueRef(a, "value", i, r), this._wire(a), new O(this._builder, a, "out");
  }
  setState(e, s) {
    const i = this._builder._addNode(p.TRACE_SET_STATE, { target: [this._builder._targetPath(e)] });
    return this._builder._setValue(i, "state", s), this._wire(i), new O(this._builder, i, "out");
  }
  branch(e, s = "value") {
    const i = this._builder._addNode(p.FLOW_BRANCH, {});
    return this._builder._setValueRef(i, "condition", e, s), this._wire(i), new Us(this._builder, i);
  }
  sequence(e = 2) {
    const s = this._builder._addNode(p.FLOW_SEQUENCE, {});
    return this._wire(s), new Xs(this._builder, s, e);
  }
  interval(e) {
    if (!(e > 0) || !Number.isFinite(e)) throw new RangeError(`interval(${e}): period must be a positive, finite number of seconds`);
    const s = Pt(this._builder, e);
    return this._wire(s.restart), new Gs(this._builder, s);
  }
  cancelInterval(e) {
    if (e.and !== this._builder) throw new Error("cancelInterval: IntervalChain belongs to a different GraphBuilder");
    this._builder._setFlow(this._prevNode, this._prevSocket, e.nodes.clear, "in");
  }
  delay(e) {
    const s = this._builder._addNode(p.FLOW_SET_DELAY, {});
    return this._builder._setValue(s, "duration", e), this._wire(s), new Hs(this._builder, s);
  }
  cancelDelay(e) {
    if (e.and !== this._builder) throw new Error("cancelDelay: DelayChain belongs to a different GraphBuilder");
    const s = this._builder._addNode(p.FLOW_CANCEL_DELAY, {});
    return this._builder._setValueRef(s, "delay", e.node, "lastDelay"), this._wire(s), new O(this._builder, s, "out");
  }
  cancelPendingDelay(e) {
    if (e.and !== this._builder) throw new Error("cancelPendingDelay: DelayChain belongs to a different GraphBuilder");
    if (e.node === this._prevNode) throw new Error("cancelPendingDelay: cannot wire a delay node into its own cancel input");
    this._builder._setFlow(this._prevNode, this._prevSocket, e.node, "cancel");
  }
  setActiveChildFrom(e, s, i = "value") {
    const r = this._builder._addNode(p.TRACE_SET_ACTIVE_CHILD, { target: [this._builder._targetPath(e)] });
    return this._builder._setValueRef(r, "index", s, i), this._wire(r), new O(this._builder, r, "out");
  }
  setVariable(e, s) {
    const i = this._builder._addNode(p.VARIABLE_SET, { variable: [e] });
    return this._builder._setValue(i, "value", s), this._wire(i), new O(this._builder, i, "out");
  }
  get and() {
    return this._builder;
  }
  build() {
    return this._builder.build();
  }
  _wire(e) {
    this._builder._setFlow(this._prevNode, this._prevSocket, e);
  }
}, mt = class _t {
  _builder;
  _node;
  constructor(e, s) {
    this._builder = e, this._node = s;
  }
  thenPlay(e, s, i) {
    const r = { target: [this._builder._targetPath(e)] };
    s && (r.clip = [s]);
    const n = this._builder._addNode(p.TRACE_PLAY_ANIMATION, r);
    return i?.loop && this._builder._setValue(n, "loop", !0), i?.speed !== void 0 && this._builder._setValue(n, "speed", i.speed), this._builder._setFlow(this._node, "done", n), new _t(this._builder, n);
  }
  get then() {
    return new P(this._builder, this._node, "out");
  }
  get whenDone() {
    return new P(this._builder, this._node, "done");
  }
  get and() {
    return this._builder;
  }
  build() {
    return this._builder.build();
  }
}, Hs = class {
  _builder;
  _node;
  constructor(t, e) {
    this._builder = t, this._node = e;
  }
  get node() {
    return this._node;
  }
  get then() {
    return new P(this._builder, this._node, "out");
  }
  get whenDone() {
    return new P(this._builder, this._node, "done");
  }
  get and() {
    return this._builder;
  }
  build() {
    return this._builder.build();
  }
}, Gs = class {
  _builder;
  _nodes;
  constructor(t, e) {
    this._builder = t, this._nodes = e;
  }
  get nodes() {
    return this._nodes;
  }
  get then() {
    return new P(this._builder, this._nodes.restart, "2");
  }
  get whenDone() {
    return new P(this._builder, this._nodes.tick, "0");
  }
  get and() {
    return this._builder;
  }
  build() {
    return this._builder.build();
  }
}, Zs = class {
  _builder;
  _inNode;
  _outNode;
  constructor(t, e, s) {
    this._builder = t, this._inNode = e, this._outNode = s;
  }
  enter() {
    return new P(this._builder, this._inNode, "out");
  }
  exit() {
    return new P(this._builder, this._outNode, "out");
  }
  get and() {
    return this._builder;
  }
}, qs = class {
  _builder;
  _node;
  constructor(t, e) {
    this._builder = t, this._node = e;
  }
  enter() {
    return new P(this._builder, this._node, "enter");
  }
  exit() {
    return new P(this._builder, this._node, "exit");
  }
  get and() {
    return this._builder;
  }
}, Us = class {
  _builder;
  _node;
  constructor(t, e) {
    this._builder = t, this._node = e;
  }
  onTrue() {
    return new P(this._builder, this._node, "true");
  }
  onFalse() {
    return new P(this._builder, this._node, "false");
  }
  get and() {
    return this._builder;
  }
}, Xs = class {
  _builder;
  _node;
  _count;
  constructor(t, e, s) {
    this._builder = t, this._node = e, this._count = s;
  }
  step(t) {
    if (t < 0 || t >= this._count) throw new RangeError(`SequenceChain.step: index ${t} out of range [0, ${this._count})`);
    return new P(this._builder, this._node, String(t));
  }
  get and() {
    return this._builder;
  }
}, Ks = "./Tracks";
function Ws(t) {
  const i = (r) => ({
    declaration: 1,
    configuration: { target: {
      type: 0,
      value: [Ks]
    } },
    values: { state: {
      type: 1,
      value: [r]
    } }
  });
  return t.tracks ? {
    types: [{ signature: "string" }, { signature: "bool" }],
    declarations: [
      { op: "event/onStart" },
      { op: "trace/setActive" },
      { op: "event/onSelect" },
      { op: "trace/isMediaPlaying" },
      { op: "flow/branch" },
      { op: "trace/pauseMedia" },
      { op: "trace/playMedia" }
    ],
    variables: [],
    events: [],
    nodes: [
      {
        declaration: 0,
        flows: { out: {
          node: 1,
          socket: "in"
        } }
      },
      i(!1),
      {
        declaration: 2,
        flows: { out: {
          node: 4,
          socket: "in"
        } }
      },
      { declaration: 3 },
      {
        declaration: 4,
        values: { condition: {
          node: 3,
          socket: "value"
        } },
        flows: {
          true: {
            node: 5,
            socket: "in"
          },
          false: {
            node: 6,
            socket: "in"
          }
        }
      },
      { declaration: 5 },
      {
        declaration: 6,
        flows: { out: {
          node: 7,
          socket: "in"
        } }
      },
      i(!0)
    ]
  } : {
    types: [{ signature: "string" }, { signature: "bool" }],
    declarations: [
      { op: "event/onSelect" },
      { op: "trace/isMediaPlaying" },
      { op: "flow/branch" },
      { op: "trace/pauseMedia" },
      { op: "trace/playMedia" }
    ],
    variables: [],
    events: [],
    nodes: [
      {
        declaration: 0,
        flows: { out: {
          node: 2,
          socket: "in"
        } }
      },
      { declaration: 1 },
      {
        declaration: 2,
        values: { condition: {
          node: 1,
          socket: "value"
        } },
        flows: {
          true: {
            node: 3,
            socket: "in"
          },
          false: {
            node: 4,
            socket: "in"
          }
        }
      },
      { declaration: 3 },
      { declaration: 4 }
    ]
  };
}
function Li(t) {
  return {
    "@type": "BehaviorGraph",
    graph: Ws(t)
  };
}
function ve(t, e) {
  let s;
  t.type === "enum" || t.type === "multiSelect" ? s = `${t.type} [${t.options.join(" | ")}]` : t.type === "object" && t.isMap ? s = "Record<string, object>" : t.type === "string" && t.arrayOf ? s = `${t.arrayOf}[]` : s = t.type;
  let i = `${e}${t.key}: ${s}`;
  return t.default !== void 0 && (i += ` = ${JSON.stringify(t.default)}`), t.description && (i += ` — ${t.description}`), i;
}
function Hi(t) {
  const e = [`## ${t.type}`], [s, ...i] = (t.description ?? "").split(/\n\s*\n/), r = i.join(`

`).trim();
  s && e.push(s), e.push("");
  for (const n of t.fields)
    if (!n.hidden) {
      if (e.push(ve(n, "  ")), n.type === "object" && n.fields.length > 0) {
        n.isMap && e.push("    (each value is an object with:)");
        for (const a of n.fields) a.hidden || e.push(ve(a, "    "));
      }
      if (n.type === "number" && n.objectFields) {
        e.push("    (or an object with:)");
        for (const a of n.objectFields) a.hidden || e.push(ve(a, "    "));
      }
      if (n.type === "array" && n.itemFields) {
        e.push("    (array items):");
        for (const a of n.itemFields) a.hidden || e.push(ve(a, "      "));
      }
    }
  if (t.actions && t.actions.length > 0) {
    e.push("", "Actions (callable via call_action):");
    for (const n of t.actions) e.push(`  ${n.name} — ${n.label}`);
  }
  return r && e.push("", r), t.docs && e.push("", t.docs), e.join(`
`);
}
var Gi = Ds();
export {
  Fe as A,
  _s as C,
  ds as D,
  us as E,
  cs as O,
  bs as S,
  fs as T,
  Ss as _,
  Ws as a,
  N as b,
  Ds as c,
  Vs as d,
  Es as f,
  Ts as g,
  xs as h,
  Li as i,
  os as j,
  Bi as k,
  Fs as l,
  Os as m,
  Hi as n,
  zi as o,
  Rs as p,
  Ks as r,
  Di as s,
  Gi as t,
  ks as u,
  As as v,
  ps as w,
  ji as x,
  Fi as y
};

//# sourceMappingURL=behaviors-0Dz87Ufy.js.map